

// TODO consolidate to the same params for all bonuses, and use separate config for per bonus config from backend

import { Elastic } from "gsap";
import { ClientState } from "../../../ClientState";

import { AddMouseDownListener, CreateElement, CreateSpineResources, Filter, FilterFeatures, Log, Point, Rect, Safe, Scale, SetStyles } from "../../.././MyHelpers";
import { AudioManager, Track } from "../../../AudioManager";
import { ISystemContext } from "../../../Context/SystemContext";
import { ITimeout } from "../../../Context/Timeout";
import { GameSession } from "../../../GameSession";
import { FontResource } from "../../../ResourceManager/FontResource";
import { DecodedImageResource, ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { RobotPlay } from "../../../RobotPlay";
import { ScatterRandomAwardCreateParams, ScatterRandomAwardResults } from "../../../slot/ScatterRandomAward/ScatterRandomAward";
import { SlotFeature } from "../../../slot/SlotFeature";
import { SlotGameType1Shared } from "../../../slot/SlotGameType1Shared";
import { SlotSymbol } from "../../../slot/SlotSymbol";
import { ReelSymbolsToDisplay } from "../../../slot/SpinAnimation/ReelMapper";
import { SpinnableReelsParams } from "../../../slot/SpinAnimation/SpinnableReels";
import { S2_ReelMapper } from "../../../slot/SpinAnimation2/ReelMapper";
import { S2_ReelSetMapper } from "../../../slot/SpinAnimation2/ReelSetMapper";
import { S2_ReelSpinAnimation, S2_ReelSpinAnimParams } from "../../../slot/SpinAnimation2/ReelSpinAnimation";
import { S2_SpinAnimation } from "../../../slot/SpinAnimation2/SpinAnimation";
import { S2_IReelConfig } from "../../../slot/SpinAnimation2/SpinnableReels";
import { GetStateNameCallback, StateChange, StateMachine } from "../../../slot/StateMachine";
import { translationMap, Translator } from "../../../Translator";
import { Panel } from "../../panel/panel";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig } from "../../SlotGame";
import { AwardOptionPosition, AwardPositionWithValue, AwardType, JackpotAwardOption, JackpotLevel, MultiBonusSpinAction, MultiBonusStartAction, MultiBonusType, PlayWindow, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, SharedJackpotWin, SimpleSlotGameState, SlotGameBet, SpinAndHoldCommonConfiguration, SpinAndHoldEndAction, SpinAndHoldSpinAction, SpinAndHoldStartAction } from "../../../api";
import { Money } from "../../../Money";
import { service } from "../../../services";
import { JackpotDisplayType, Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
import { S2_ReelSpinAnimationUpdateParams } from "../../SpinAnimation2/ReelSpinAnimation";
import { ITransition } from "../../Transition/ITransition";
import { ITransitionFactory } from "../../Transition/ITransitionFactory";
import { TransitionFactory } from "../../Transition/TransitionFactory";
import { LoadingItem } from "../LoadingItem";
import { ConstructReelsParams, SlotBonus } from "../SlotBonus";
import { SpinAndHoldParams } from "./SpinAndHoldParams";
import { SpinAndHoldRunResult } from "./SpinAndHoldRunResult";
import { SpinAndHoldSession } from "./SpinAndHoldSession";
import { SpinAndHoldState } from "./SpinAndHoldState";
import gsap from 'gsap';
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from 'pixi.js';
import { assertNotLess, assertNotNullish } from "../../../debug";
import { JackpotShowtimeDuration } from "../../../JackpotProperties";
import { enableJackpotSharedMap, JackpotSharedShow } from "../../../JackpotSharedShow";
import { AtlasResource } from "../../../ResourceManager/AtlasResource";
import { JSONResource } from "../../../ResourceManager/JSONResource";
import { JackpotValuesReset, ScreenProtocolScope } from "../../../ScreenProtocol";
import { ParseMonitors } from "../../../system/ParseMonitors";
import { BonusMultiplierShowStats } from "../../BonusMultiplier";
import { CometFactory } from "../../CometFeature/CometFactory";
import { ICometFactory, ICometInterfacePIXIAPP } from "../../CometFeature/ICometInterface";
import { ActionStats, HistoryStats } from "../../IHistoyGame";
import { ScatterRandomAwardPIXI } from "../../ScatterRandomAward/ScatterRandomAwardPIXI";
import { ChangeSpeedParams } from "../../SlotGameType1";
import { S2_ISpinnableReelPIXI, S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { ITransitionFactoryPIXIAPP } from "../../Transition/ITransitionFactoryPIXIAPP";
import { TransitionFactoryPIXIAPP } from "../../Transition/TransitionFactoryPIXIAPP";
import { AwardJPShowPIXAPP } from "./AwardJPShowPIXAPP";
import { HoldingFeatureParamsPIXI, HoldingFeaturePIXIApp } from "./HoldingFeaturePIXIApp";
import { JackpotDisplayProperties } from "../../../JackpotDisplayProperties";


interface TextureDialogLanguage {
	textureBonusIntro : any;
	textureBonusFinal : any;
}

export const jackpoShowDuration: Partial<Record<JackpotLevel, number>> =
{
    jp1 : 3200,
	jp2 : 3200,
	jp3 : 31000,
	jp4 : 45000,

};

export class SpinAndHoldBonusPIXIAPP extends SlotBonus implements Resourceful2 {
	public override OnResize(): void {
		throw new Error("Method not implemented.");
	}

	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		// disable por ahora, hasta que se resuelve.
		// this.reelSpinAnimations.forEach(animation => {
		// 	animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		// });
		// this.commetView.UpdateCometAnimation(changeSpeedParams.CelebrationFactor)
	}

	public override CreateTransitionPixi(app : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}
	protected params: SpinAndHoldParams = null;
	protected config: SpinAndHoldCommonConfiguration = null;
	protected view: HTMLElement = null;
	protected session: SpinAndHoldSession = null;
	protected stateMachine: StateMachine<SpinAndHoldState> = new StateMachine<SpinAndHoldState>(SpinAndHoldState.Idle, this.logGroup, (state: SpinAndHoldState) => SpinAndHoldState[state]);
	protected spinnableReels2: S2_SpinnableReelsBigCanvas2 = null;
	protected spinAnimation2: S2_SpinAnimation = null;
	protected reelSetMapper2: S2_ReelSetMapper = null;
	// EXPANDING WILD FEATURE
	private features: Map<string, SlotFeature> = new Map<string, SlotFeature>();
	protected scatterRandomAwardFeature: ScatterRandomAwardPIXI = null;
	protected holdingFeature: HoldingFeaturePIXIApp = null;
	//CHANGE COLOR FOR AWARD 
	//SEND COLOR 
	protected color: string = "white";
	protected coloroutherStroke: string = "black";
	protected colorinnerStroke: string = "red";
	// spin delay, in millis
	//private autoSpinTimer: SingleShotTimer= new SingleShotTimer(() => this.AutoSpin(), 3000);
	private autoSpinTimer: number = null;
	protected lastSpinResult: SpinAndHoldRunResult = null;
	protected scatterPositions: AwardPositionWithValue[] = null;
	// win lines or colelct can be interrupted, 
	// when interrupted, start new spin right away 
	private spinInterrupted: boolean = false;

	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = { balance: 0, win: 0 };
	protected panel: Panel;
	protected audio: AudioManager = null;
	protected override parentresid: ResourceIdentifier = null;	
	protected clientState: ClientState = null;
	protected translator: Translator;
	protected robotPlay: RobotPlay;
	protected demoMessage: HTMLElement = null;
	protected VoicePlay: boolean = true;
	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected systemContext: ISystemContext = null;
	protected requiredSymbol: string = "SRA";
	protected commetFactory : ICometFactory = new CometFactory();
	protected commetView : ICometInterfacePIXIAPP = null;

	// index of the scatter, for which to show the comet
	protected currentScatterCometIndex: number = -1;
	
	//Create some canvas for button text dialog
	//protected buttonStartCanvas: MyCanvas;
	//protected buttonExitCanvas: MyCanvas;

	protected fontHeight:number=Scale.fh(135);
	protected fontFamily: string;
    protected JackpotVideoResource:string=null;
	
	protected transitionView: ITransition = null;
	public get TransitionView(): ITransition {
		return this.transitionView;
	};
	protected transitionViewFactory:ITransitionFactory= new TransitionFactory();
	protected backgroundSpinHoldGame: HTMLElement = null;

	//Machine is locked 
	protected isLocked : boolean = false ; 


	protected BonusName(): string
	{
		return "SpinAndHold";
	}

	//create intervals anim 	
	protected intervalvideoFadeOutTimer: ITimeout = null;
	protected intervalStopFountainTimer: ITimeout = null;
	protected timeoutFinalMessageState : ITimeout = null;
	protected timeoutStartCometCollect : ITimeout = null;
	protected timeoutSRAPlusOne : ITimeout = null;
	protected timeoutAutoSpin : ITimeout =  null;

	//protected bonusAppView : BonusAppPixi = null;

	protected loadingSequence: LoadingItem[] = [
		{Name: "Base",				Prepare: (r) => this.BasePrepare(r),				Loaded: (r) => this.BaseLoaded(r)},
		{Name: "Containers",		Prepare: null,										Loaded: (r) => null },
		{Name: "ViewAppBonus",		Prepare: (r) => null,								Loaded: (r) => this.LoadedResourcesBonusViewApp(r)},
		{Name: "ReelBackground",	Prepare: (r) => this.PrepareBackgroundReel(r),		Loaded:  (r) => this.ReelsLoaded(r)},
		//{Name: "Reel",				Prepare: (r) => this.ConstructReels2(),			Loaded: (r) => this.ReelsLoaded(r)},
		{Name: "Audio",				Prepare: (r) => this.AudioPrepare(r),				Loaded: null},
		{Name: "Features",			Prepare: (r) => this.FeaturesPrepare(r),			Loaded: (r) => this.FeaturesLoaded(r)},
		{Name: "BigWin",			Prepare: (r) => this.BigWinPrepare(r),				Loaded: (r) => this.BigWinLoaded(r)},
		{Name: "History",			Prepare: (r) => this.PrepareHistory(r),				Loaded: (r) => this.LoadedHistory(r)},
		{Name: "Comets",			Prepare: (r) => this.CometsPrepare(r),				Loaded: (r) => this.CometsLoaded(r)},
		// {Name: "Video",				Prepare: (r) => this.PrepareVideos(r),				Loaded: (r) => this.VideosLoaded(r)},
		{Name: "Demo",				Prepare: null,										Loaded: (r) => this.DemoLoaded(r)},
		//{Name: "Display",			Prepare: null,										Loaded: (r) => this.HideAllContainers()},
		{Name: "TitleTransition",   Prepare: (r) => this.PrepareTransition(r),     		Loaded: (r) => this.TransitionLoaded(r)},
	];

	protected awardJPShowPIXIAPP : AwardJPShowPIXAPP = null;

	protected jackpotSharedShow : JackpotSharedShow = null;

	//Create Multiplier Show Stats 
	protected bonusMultiplier : BonusMultiplierShowStats = null;
	

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params);

		this.params = params;
		this.config = config;

		this.session = new SpinAndHoldSession("Screen-1");

		this.parentresid = params.resid;
		//this.translator=translator;
		this.translator = params.translator;

		//this.screenProtocol = params.screenProtocol;
		//this.screenProtocolScope = params.screenProtocolScope.Add("SpinAndHold");

		this.panel = params.panel;

		this.audio = params.audio;
		this.clientState = params.clientState;
		this.systemContext = params.systemContext.CreateSubContext(this.bonusName);

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add(this.bonusName);
		this.jackpotName = Settings.JackpotDisplayType;
		if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias) this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;



		this.backgroundSpinHoldGame = CreateElement("div",{
			classes:[this.resid.Scope(), "BackgroundBonusGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080*Settings.Screens),
				position: "absolute",
				bottom: Settings.Screens == 2 ? Scale.Ypx(0)  :  Scale.Ypx(0),
				//backgroundColor: "red",
				//zIndex: ZIndex.backgroundBaseGame.toString(),
			}
		});

		// TODO move to some common place?
		if (params.slotGameMeta.Demo == true) {
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
				{
					position: "absolute",
					top: Scale.Ypx(86),
					right: Scale.Xpx(0),
					width:  Scale.Wpx(307),
					height: Scale.Hpx(86),
					fontSize: Scale.fhpx(99),
					letterSpacing: Scale.fhpx(5),
					fontFamily: "NotoSansDisplay-ExtraBold",
					color: "rgba(255, 0, 0, 1)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					transform: "rotate(45deg)",
					zIndex:ZIndex.DemoMessage.toString(),
				})

			this.demoMessage.innerHTML = "DEMO";
		}


		

		//this.denomMessage = document.createElement("div");
		//this.denomMessage.classList.add("denom-message");

		this.stateMachine.SetCallback(SpinAndHoldState.IntroTransition, StateChange.Begin, () => this.OnIntroTransitionBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.IntroTransition, StateChange.End, () => this.OnIntroTransitionEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());
	    void service.api?.registerOperation("MachineLock",   this.resid.ID(), (data) =>{this.isLocked= true;});
	    void service.api?.registerOperation("MachineUnlock", this.resid.ID(), () =>{this.isLocked= false;});
		

		// this.stateMachine.SetCallback(SpinAndHoldState.Pick, StateChange.Begin, () => this.OnPickBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Pick, StateChange.End, () => this.OnPickEnd());

		// this.stateMachine.SetCallback(SpinAndHoldState.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		// this.stateMachine.SetCallback(SpinAndHoldState.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());
		//this.stateMachine.SetCallback(SpinAndHoldState.Running, StateChange.Begin, () => this.OnRunningBegin());

		this.stateMachine.SetCallback(SpinAndHoldState.MultiplierShow, StateChange.Begin, () => this.NextScatterMultiplier());

		this.stateMachine.SetCallback(SpinAndHoldState.WaitFirstSpin, StateChange.Begin, () => this.OnWaitFirstSpinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.BigWin, StateChange.Begin, () => this.OnBigWinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.BigWin, StateChange.End, () => this.OnBigWinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Win, StateChange.Begin, () => this.OnWinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Win, StateChange.End, () => this.OnWinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Collect, StateChange.Begin, () => this.OnCollectBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.SpinIdle, StateChange.Begin, () => this.OnSpinIdleBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.SpinIdle, StateChange.End, () => this.OnSpinIdleEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.CometCollect, StateChange.Begin, () => this.OnCometCollectBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.CometCollect, StateChange.End, () => this.OnCometCollectEnd());


		this.stateMachine.SetCallback(SpinAndHoldState.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());	

		this.stateMachine.SetStateChangeCallback((oldState: SpinAndHoldState, newState: SpinAndHoldState, stateNameCallback: GetStateNameCallback<SpinAndHoldState>) => {
			// Log.Debug(this.logGroup, "Changing state " + stateNameCallback(oldState) + " to " + stateNameCallback(newState));
		});

		this.robotPlay = params.robotPlay;

		
		this.timeoutFinalMessageState = this.systemContext.TimingContext().CreateTimeout("timeoutFinalMessageState", 700, () => {			
			this.stateMachine.ChangeState(SpinAndHoldState.FinalMessage)
		});
		this.timeoutStartCometCollect = this.systemContext.TimingContext().CreateTimeout("timeoutStartCometCollect",2500,()=>{
			this.stateMachine.ChangeState(SpinAndHoldState.CometCollect)
		});

		this.timeoutSRAPlusOne = this.systemContext.TimingContext().CreateTimeout("timeoutSRAPlusOne", 500, () => {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
			// send when animation is finished, move to separate timeout if necessary
			//this.screenProtocol?.Send(new SpinAndHoldMessages.PlusMessage(this.session), this.screenProtocolScope);
			this.spineBonusTitle?.state?.setAnimation(0,"anim",false);
			if(this.spinRemainingTextPIXIAPP != null)this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining;
		});

	    this.timeoutAutoSpin = this.systemContext.TimingContext().CreateTimeout("timeoutAutoSpin", 1000, () => { this.AutoSpin()});

		this.awardJPShowPIXIAPP = new AwardJPShowPIXAPP();
		if (enableJackpotSharedMap[Settings.JackpotDisplayType] == true) {			
			this.jackpotSharedShow = new JackpotSharedShow(this.audio,this.resid);
		}		

		this.bonusMultiplier = new BonusMultiplierShowStats(null,this.audio,this.resid);

		

		this.stateMachine.SetStateChangeCallback((oldState: SpinAndHoldState, newState: SpinAndHoldState, stateNameCallback: GetStateNameCallback<SpinAndHoldState>) => {
			Log.Debug(this.logGroup, `State changed from ${stateNameCallback(oldState)} to ${stateNameCallback(newState)}`);
		});
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{

		if(loadingStage == LoadingStage.GamesPreload) await this.PrepareSpineResources(resourceManager);
		

		for (let item of this.loadingSequence)
		{
			await item.Prepare?.(resourceManager);
		};
	}

	protected async PrepareSpineResources (resourceManager: IWriteOnlyResourceManager){
		let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine`; 
		//Title Prepare 				
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/TitleBonusStickySpin/TitleBonusStickySpin.json`, ResourceIdentifier.Global.ScopedResourceName(`TitleBonusStickySpinSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/TitleBonusStickySpin/TitleBonusStickySpin.atlas`, ResourceIdentifier.Global.ScopedResourceName(`TitleBonusStickySpinSpineATLAS`)));

		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/WinCount/WinCount.json`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/WinCount/WinCount.atlas`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineATLAS`)));

		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.json`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.atlas`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineATLAS`)));
		
		//winAwardFrame Prepare
		let pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.json`;
		let pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.atlas`;
		if (Settings.JackpotDisplayType == JackpotDisplayType.RainbowGirls) {
			pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.json`;
			pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.atlas`;
		}
		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(pathWinAwardBonusJSON, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(pathWinAwardBonusATLAS, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineATLAS`)));


		//BonusTitlePrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleATLAS`)));


		//create award show 
		await this.awardJPShowPIXIAPP.PrepareResources(resourceManager);

		await this.jackpotSharedShow?.PrepareResources(resourceManager);

		await this.bonusMultiplier?.PrepareResources(resourceManager);	
	}

	public async AudioPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> 
	{
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transitionaudio")));
		//this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/final" + Settings.audioFormat, this.resid.ScopedResourceName("final")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegameintro" + Settings.audioFormat, this.resid.ScopedResourceName("intro")));
		//Load Voice Diamond POT
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/BounceSound" + Settings.audioFormat, this.resid.ScopedResourceName("bounceSound")));



		

		if ( Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
		{
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp3Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp3Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp4Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp4Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp2Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp2Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp1Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp1Voice")));							
		}		
		else{
			throw `Spin And Hold Its Not implemented for AudioPrepare ${Settings.JackpotDisplayType}`;
		}


		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
			//load jackpot sound effect
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/JackpotShow/" + this.jackpotName + "/tracks/jp1Background" + Settings.audioFormat, this.resid.ScopedResourceName("jp1Background") , false));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/JackpotShow/" + this.jackpotName + "/tracks/jp2Background" + Settings.audioFormat, this.resid.ScopedResourceName("jp2Background") , false));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/JackpotShow/" + this.jackpotName + "/tracks/jp3Background" + Settings.audioFormat, this.resid.ScopedResourceName("jp3Background") , false));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/JackpotShow/" + this.jackpotName + "/tracks/jp4Background" + Settings.audioFormat, this.resid.ScopedResourceName("jp4Background") , false));
			//this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/" + Settings.JackpotDisplayType + "/tracks/clasploop" + Settings.audioFormat, this.resid.ScopedResourceName("clasploop")));
		} else {
			//load jackpot sound effect
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Emeraldwin" + Settings.audioFormat, this.resid.ScopedResourceName("jp1Background")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Emeraldwin" + Settings.audioFormat, this.resid.ScopedResourceName("jp2Background")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Rubywin" + Settings.audioFormat, this.resid.ScopedResourceName("jp3Background")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Diamondwinfull" + Settings.audioFormat, this.resid.ScopedResourceName("jp4Background")));			
		}
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/clasploop" + Settings.audioFormat, this.resid.ScopedResourceName("clasploop")));
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		// Log.Debug(this.logGroup, "Resources loaded...");
		// await SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager, this.params.jackpotEnable);

		if(loadingStage == LoadingStage.Games){
			await this.CreateTextureBonusTitleSpineLoaded(resourceManager);		
			await this.jackpotSharedShow?.ResourcesLoaded(resourceManager);
			await this.bonusMultiplier?.ResourcesLoaded(resourceManager);	
		}

		for (let item of this.loadingSequence)
		{
			await item.Loaded?.(resourceManager);
		};
	}

	protected jsonBonusTitleSpine: ISkeletonData = null;
	protected jsonWinCountSpine: ISkeletonData = null;
	protected jsonSpinsRemainingSpine: ISkeletonData = null;
	protected jsonWinAwardBonusSpine: ISkeletonData = null;
	protected jsonBonusWinTitleSpine: ISkeletonData = null;
	protected async CreateTextureBonusTitleSpineLoaded(resourceManager: IReadOnlyResourceManager){

		let bonusTitleSpineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`TitleBonusStickySpinSpineJson`));
		let bonusTitleSpine = await PIXI.Assets.load(bonusTitleSpineTextureJson.path).finally(() => {
					PIXI.Assets.cache.remove(bonusTitleSpineTextureJson.path);
				});;
		this.jsonBonusTitleSpine = bonusTitleSpine.spineData;

		bonusTitleSpineTextureJson = null;
		bonusTitleSpine = null;
		
		let spineWinCountSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineJson`));
		let spineWinCountAssets = await PIXI.Assets.load(spineWinCountSpineJson.path).finally(() => {
					PIXI.Assets.cache.remove(spineWinCountSpineJson.path);
				});;
		this.jsonWinCountSpine = spineWinCountAssets.spineData;

		spineWinCountSpineJson = null;
		spineWinCountAssets = null;
		

		let spineSpinsRemainingSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineJson`));
		let spineSpinsRemainingAssets = await PIXI.Assets.load(spineSpinsRemainingSpineJson.path).finally(() => {
					PIXI.Assets.cache.remove(spineSpinsRemainingSpineJson.path);
				});;
		this.jsonSpinsRemainingSpine = spineSpinsRemainingAssets.spineData;

		spineSpinsRemainingSpineJson = null;
		spineSpinsRemainingAssets = null;

		let spineWinAwardBonusSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineJson`));
		let spineWinAwardBonusAssets = await PIXI.Assets.load(spineWinAwardBonusSpineJson.path).finally(() => {
					PIXI.Assets.cache.remove(spineWinAwardBonusSpineJson.path);
				});;
		this.jsonWinAwardBonusSpine = spineWinAwardBonusAssets.spineData;

		spineWinAwardBonusSpineJson = null;
		spineWinAwardBonusAssets = null;
 
		let bonusWinTitleJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleJson`));
		let bonusWinTitlAssets= await PIXI.Assets.load(bonusWinTitleJson.path).finally(() => {
					PIXI.Assets.cache.remove(bonusWinTitleJson.path);
				});;
		this.jsonBonusWinTitleSpine =bonusWinTitlAssets.spineData;

		bonusWinTitleJson = null;
		bonusWinTitlAssets = null;

		await this.awardJPShowPIXIAPP.ResourcesLoaded(resourceManager);
	}



	// protected async PrepareVideos(resourceManager: IWriteOnlyResourceManager): Promise<void>
	// {
	// 	// paytable jackpot display type does not have jackpot, no videos
	// 	if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {
	// 		return;
	// 	}

	// 	// when using spine background, videos are not used

	// 	this.JackpotVideoResource = "multigame/slot/common/resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.Screens + "-screenResources";

	// 	//if (this.JackpotVideoResource) {
	// 	resourceManager.AddGlobal(new VideoResource2({
	// 		resid: ResourceIdentifier.Global.Add("jp4"),
	// 		logGroup: LogGroup.Global.Add("JP4Video"),
	// 		src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp4",
	// 		unloadOnEnd: true
	// 	}));


	// 	resourceManager.AddGlobal(new VideoResource2({
	// 		resid: ResourceIdentifier.Global.Add("jp3"),
	// 		logGroup: LogGroup.Global.Add("JP3Video"),
	// 		src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp3",
	// 		unloadOnEnd: true
	// 	}));

	// 	resourceManager.AddGlobal(new VideoResource2({
	// 		resid: ResourceIdentifier.Global.Add("jp2"),
	// 		logGroup: LogGroup.Global.Add("JP2Video"),
	// 		src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp2",
	// 		unloadOnEnd: true
	// 	}));


	// 	resourceManager.AddGlobal(new VideoResource2({
	// 		resid: ResourceIdentifier.Global.Add("jp1"),
	// 		logGroup: LogGroup.Global.Add("JP1Video"),
	// 		src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp1",
	// 		unloadOnEnd: true
	// 	}));
	// }

	

	public async PrepareTransition(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{

		// let pathTrack: string;
		// let pathSprite: string;
		// let pathVideo: string;
		// if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
		// 	let pathTrack = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/" + Settings.JackpotDisplayType + Settings.audioFormat;
		// 	let pathSprite = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.JackpotDisplayType + "_Transition";
		// 	let pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/Background_" + Settings.Screens + "S";
		// 	//Overwrite this video path because for this jackpots need different 
		// 	if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
		// 		pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + Settings.Screens + "s";
		// 		//pathTrack  = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/DiamondPot" + Settings.audioFormat;
		// 	}

		// 	//if(Settings.JackpotDisplayType !+ JackpotDisplayType.DiamondPotStepShared && Settings.JackpotDisplayType != JackpotDisplayType.DiamondPotStepSinShared ) resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
		// 	if(globalThis.jackpotDisplayGlobal.GetSpineSkeleton() == null)  resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
		// 	this.audio.AddTrack(new Track(pathTrack, this.resid.ScopedResourceName("VoiceJackpotType")));

		// 	if (Settings.PresentationType == Presentation.VideoGameSprite) {
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
		// 		pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundVideoSprite_" + Settings.Screens + "S";
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.Image) {
		// 		let pathImgTransition = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundTransition_" + Settings.Screens + "S.png";
		// 		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
		// 			pathImgTransition = `${this.params.gamepath}resources/BackgroundTransition_${Settings.Screens}S.png`;
		// 		}
		// 		resourceManager.AddGlobal(new ImageResource(pathImgTransition,
		// 			ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + Settings.Screens).Scope()));
				
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
		// 		pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/BackgroundCommonVideo_" + Settings.Screens + "S";
		// 		resourceManager.AddGlobal(new VideoResource2({
		// 			resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
		// 			logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + Settings.Screens),
		// 			src: pathVideo,
		// 			unloadOnHide: true
		// 		}));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
		// 		resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
		// 		// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
		// 		// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		// 	}
		// 	else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
		// 		resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
		// 		// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
		// 		// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
		// 	}
		// }
		// else {
		// 	throw `Spin And Hold Its Not implemented for PrepareTransition ${Settings.JackpotDisplayType}`;
		// }

		let transitionResources = {				
				audio: this.audio,				
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,								
				fadeOut: true,								
				skelentonDataSpine : globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton() ?? null,	
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,	
				bonusCommonPath : this.params.commonBonusResourcesBasePath,
				bonusName: this.bonusName,
		};

		let transitionViewFactory: ITransitionFactoryPIXIAPP = new TransitionFactoryPIXIAPP()
		this.transitionView = await transitionViewFactory.CreatePIXIAPP(transitionResources);				
		await this.transitionView?.PrepareResources(resourceManager);
		
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}

		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
	}

	
	protected EnableFadeOutVideo():boolean{
		return true;
	}

	// //LOAD FOR TRANSITION 
	public async TransitionLoaded(resourceManager: IReadOnlyResourceManager)
	{		
		await this.transitionView?.ResourcesLoaded(resourceManager);			
	}
	
	// //ADD THIS OVERWRITE FOR FIX VIDEO BACKGROUND FOR JP WIN SHOW 
	// //ONLY 2Screen and 3 use video 
	// protected async VideosLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		
	// 	//if(Settings.Screens == 3)
	// 	//{
	// 		// make sure jackpot videos loop
	// 		let jp4 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp4")).video;
	// 		//jp4.video.loop = true;
	// 		SetStyles(jp4.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
	// 		this.systemContext.SharedVideoContext().AddVideo(jp4);

	// 		let jp3 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp3")).video;
	// 		//jp3.video.loop = true;
	// 		SetStyles(jp3.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
	// 		this.systemContext.SharedVideoContext().AddVideo(jp3);

	// 		let jp2 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp2")).video;
	// 		//jp2.video.loop = true;
	// 		SetStyles(jp2.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
	// 		this.systemContext.SharedVideoContext().AddVideo(jp2);

	// 		let jp1 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp1")).video;
	// 		//jp1.video.loop = true;
	// 		SetStyles(jp1.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
	// 		this.systemContext.SharedVideoContext().AddVideo(jp1);

			
	// 		// if(Settings.Screens == 3)
	// 		// {
	// 		// let transitionVideo: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName)).video;
	// 		// SetStyles(transitionVideo.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0),zIndex:ZIndex.BonusTransition.toString() });
	// 		// this.systemContext.SharedVideoContext().AddVideo(transitionVideo);
	// 		// transitionVideo.AddOnPlayCallback(this.resid, () => this.OnTransitionStarted());
	// 		// transitionVideo.AddOnEndedCallback(this.resid, () => this.OnTransitionEnded());
	// 		// }
	// 		// else
	// 		// {
	// 		// 	//DONT USE for 2SCreen Games
	// 		// }
			
	// 	//}
	// }


	// protected ButtonCanvasText(resourceManager: IReadOnlyResourceManager)
	// {
	// 	this.buttonStartCanvas = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
	// 		style: {
	// 			left: Scale.Xpx(8),
	// 			top: Scale.Ypx(12),
	// 			position: "relative",
	// 			zIndex: ""+ ZIndex.BonusWin
	// 		}
	// 	});

	// 	this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);

	// 	this.buttonExitCanvas = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
	// 		style: {
	// 			left: Scale.Xpx(8),
	// 			top: Scale.Ypx(12),
	// 			position: "relative",
	// 			zIndex: ""+ ZIndex.BonusWin
	// 		}
	// 	});

	// 	this.SetTextCanvas(this.translator.t.freegameExit, this.buttonStartCanvas);
	// }

	// public SetTextCanvas(text: string, canvas: MyCanvas)
	// {
	// 	canvas.context.clearRect(0, 0, canvas.size.width,canvas.size.height);

	// 	let gradient = canvas.context.createLinearGradient( 
	// 		canvas.size.width / 2, 
	// 		canvas.size.height / 2 - this.fontHeight/2, 
	// 		canvas.size.width / 2, 
	// 		canvas.size.height /2 + this.fontHeight/2
	// 	);

	// 	gradient.addColorStop(0,    "#F2E416");
	// 	gradient.addColorStop(0.25, "#F2BE22");
	// 	gradient.addColorStop(0.50, "#C2760E");
	// 	gradient.addColorStop(0.75, "#F2BE22");
	// 	gradient.addColorStop(1,    "#F2E416");

	// 	canvas.context.fillStyle = gradient;

	// 	canvas.context.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;
	// 	canvas.context.textBaseline = "middle";
	// 	canvas.context.textAlign="center";
	// 	canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
	// 	canvas.context.miterLimit = 2;

	// 	canvas.context.strokeStyle = "black";
	// 	canvas.context.lineWidth = Scale.fh(22);
	// 	canvas.context.strokeText(text, canvas.size.width / 2, canvas.size.height / 2);
	// 	canvas.context.strokeText(text, canvas.size.width / 2, canvas.size.height / 2);
	// 	canvas.context.fillText(text,   canvas.size.width / 2, canvas.size.height / 2);

	// 	gradient = null;
	// 	canvas = null;
	// }

	protected async CreateAppBonusView() : Promise<void>  {		
		// this.bonusAppView = new BonusAppPixi(this.resid, this.systemContext);
		// this.bonusAppView.OnCreatedCallback = () => {
		// 	this.spinnableReels2.Create(this.bonusAppView.GetAppView());
		// };

		// this.view.appendChild(this.bonusAppView.GetView());
	}


	protected textureDialogBonus: PIXI.Texture<PIXI.Resource>;
	protected textureButtonBonus: PIXI.Texture<PIXI.Resource>;
	protected textureIntroBonus: PIXI.Texture<PIXI.Resource> [] = [];
	protected textureFinalBonus: PIXI.Texture<PIXI.Resource> [] = [];

	
	protected textureByLanguage : Record <keyof typeof translationMap , TextureDialogLanguage > = {
		romanian: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		spanish: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		english: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		}
	}

	protected async SetContainers(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		// await this.ButtonCanvasText(resourceManager);
		// await this.PrepareIntroMessage(resourceManager);	
		// await this.PrepareFinalMessage(resourceManager);
		// await this.PrepareReelsContainer(resourceManager);

		// this.containers.set(SpinAndHoldContainer.IntroMessage, this.introMessageContainer);
		// this.containers.set(SpinAndHoldContainer.Reels, this.reelsContainer);
		// this.containers.set(SpinAndHoldContainer.FinalMessage, this.finalMessageContainer);
	}

	protected async LoadedResourcesBonusViewApp(resourceManager: IReadOnlyResourceManager){
		let dialogTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["dialog", "image"]));
        //dialogTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureDialogBonus = PIXI.Texture.from(dialogTexturesDecoded.DecodedImage());


		let buttonTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["button", "image"]));
        //buttonTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureButtonBonus = PIXI.Texture.from(buttonTexturesDecoded.DecodedImage());


		//create texture englis y rumano
		//intro
		let introEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "english"]));
		let introEnglishTexture = PIXI.Texture.from(introEnglishTexturesDecoded.DecodedImage());
        this.textureIntroBonus.push(introEnglishTexture);
		this.textureByLanguage.english.textureBonusIntro = introEnglishTexture;


		//end
		let finalEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "english"]));
        let finalEnglishTexture = PIXI.Texture.from(finalEnglishTexturesDecoded.DecodedImage());
        this.textureFinalBonus.push(finalEnglishTexture);
		this.textureByLanguage.english.textureBonusFinal = finalEnglishTexture;

		// create testure spanish		
		//intro
		let introSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "spanish"]));
		let introSpanishTexture = PIXI.Texture.from(introSpanishTexturesDecoded.DecodedImage());
        this.textureIntroBonus.push(introSpanishTexture);
		this.textureByLanguage.spanish.textureBonusIntro = introSpanishTexture;
		//end
		let finalSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "spanish"]));
		let finalSpanishTexture = PIXI.Texture.from(finalSpanishTexturesDecoded.DecodedImage());
        this.textureFinalBonus.push(finalSpanishTexture);
		this.textureByLanguage.spanish.textureBonusFinal = finalSpanishTexture;
	}


	// protected PrepareIntroMessage(resourceManager: IReadOnlyResourceManager): void {
	// 	this.introMessageContainer = CreateElement("div", {
	// 		classes: ["introMessageContainer"], 
	// 		style:
	// 		{
	// 			position: "absolute",
	// 			bottom: Scale.Ypx(0),
	// 			left: Scale.Xpx(0),
	// 			width: Scale.Wpx(1920),
	// 			height: Scale.Hpx(1080),
	// 			zIndex:ZIndex.BonusCofirmMessage.toString(),
	// 		}
	// 	});

	// 	let messageContainer: HTMLElement = CreateElement("div", {
	// 		classes: ["messageContainer"], parentToAppend: this.introMessageContainer,
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1920),
	// 			height: Scale.Hpx(1080),
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center",
	// 			color: "yellow",
	// 			//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,
	// 		}
	// 	});

	// 	let dialog: HTMLElement = CreateElement("div", {
	// 		classes: ["dialog"], parentToAppend: messageContainer,
	// 		style:
	// 		{
	// 			position: "absolute",
	// 			width: Scale.Wpx(1152),
	// 			height: Scale.Hpx(648),
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
	// 			justifyContent: "center",
	// 			alignContent: "center",
	// 			zIndex: ZIndex.JPType.toString(),
	// 		}
	// 	});


	// 	let buttonContainer: HTMLElement = CreateElement("div", {
	// 		classes: ["buttonContainer"], parentToAppend: dialog,
	// 		style:
	// 		{
	// 			position: "absolute",
	// 			bottom: Scale.Ypx(-129),
	// 			width: Scale.Wpx(1152),
	// 			height: Scale.Hpx(300),
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center"
	// 		}
	// 	})

	// 	let button: HTMLElement = CreateElement("div", {
	// 		classes: ["button"], parentToAppend: buttonContainer,
	// 		style:
	// 		{
	// 			width: Scale.Wpx(600),
	// 			height: Scale.Hpx(300),
	// 			fontSize: Scale.fhpx(100),
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
	// 		}
	// 	});


	// 	let textIntroSpanish = CreateElement("div", {
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1052),
	// 			height: Scale.Hpx(548),
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "spanish"])).CssBackground(),
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			position:"absolute",
	// 			top: Scale.Ypx(-24),
	// 			left: Scale.Xpx(51),
	// 		}
	// 	});

	// 	let textIntroEnglish = CreateElement("div", {
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1052),
	// 			height: Scale.Hpx(548),
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "english"])).CssBackground(),
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			position:"absolute",
	// 			top: Scale.Ypx(-24),
	// 			left: Scale.Xpx(51),
	// 		}
	// 	});

	// 	dialog.appendChild(this.translator.Anchor(() => this.translator.t.BigFG(textIntroSpanish.outerHTML, textIntroEnglish.outerHTML)));
		
	// 	this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
	// 	button.appendChild(this.buttonStartCanvas.View());
	
	// 	AddMouseDownListener(button, () => {
	// 		if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
	// 			// Log.Debug(this.logGroup, "Intro message confirmed");
	// 			this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);
	// 		}
	// 		else {
	// 			Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
	// 		}
	// 	});
	// }

	// protected PrepareFinalMessage(resourceManager: IReadOnlyResourceManager): void
	// {
	// 	this.finalMessageContainer = CreateElement("div", {classes:["finalMessageContainer"], parentToAppend: this.view, 
	// 		style:
	// 		{
	// 			position:"absolute",
	// 			bottom: Scale.Ypx(0),
	// 			left: Scale.Xpx(0),
	// 			width: Scale.Wpx(1920),
	// 			height: Scale.Hpx(1080),
	// 			zIndex:ZIndex.BonusCofirmMessage.toString(),
	// 		}
	// 	});

	// 	let messageContainer: HTMLElement = CreateElement("div", {classes:["messageContainer"], parentToAppend: this.finalMessageContainer,
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1920),
	// 			height: Scale.Hpx(1080),
	// 			display:"flex",
	// 			justifyContent:"center",
	// 			alignItems:"center",
	// 			color:"yellow",
	// 			//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,

	// 		}
	// 	});

	// 	let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
	// 		style:
	// 		{
	// 			position:"absolute",
	// 			width: Scale.Wpx(1152),
	// 			height: Scale.Hpx(648),
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
	// 		}
	// 	});

	// 	let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
	// 		style:
	// 		{
	// 			position:"absolute",
	// 			bottom: Scale.Ypx(-129),
	// 			width: Scale.Wpx(1152),
	// 			height: Scale.Hpx(300),
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center"
	// 		}
	// 	})
		
	// 	let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
	// 		style:
	// 		{
	// 			width: Scale.Wpx(600),
	// 			height: Scale.Hpx(300),
	// 			fontSize: Scale.fhpx(100),
	// 			display: "flex",
	// 			justifyContent:"center",
	// 			alignItems:"center",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			backgroundRepeat:"no-repeat",
	// 			backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
	// 		}
	// 	});

	// 	let freegameTextFinalSpanish = CreateElement("span", {
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1052),
	// 			height: Scale.Hpx(548),
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "spanish"])).CssBackground(),
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			position: "absolute",
	// 			top: Scale.Ypx(-24),
	// 			left: Scale.Xpx(51),
	// 		}
	// 	});

	// 	let freegameTextFinalEnglish = CreateElement("span", {
	// 		style:
	// 		{
	// 			width: Scale.Wpx(1052),
	// 			height: Scale.Hpx(548),
	// 			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "english"])).CssBackground(),
	// 			backgroundRepeat: "no-repeat",
	// 			backgroundSize: "contain",
	// 			backgroundPosition: "center",
	// 			verticalAlign: "middle",
	// 			position:"absolute",
	// 			top: Scale.Ypx(-24),
	// 			left: Scale.Xpx(51),
	// 		}
	// 	});

	// 	dialog.appendChild(this.translator.Anchor(() =>this.translator.t.BigFG(freegameTextFinalSpanish.outerHTML,freegameTextFinalEnglish.outerHTML)));

	// 	this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas);	
	// 	button.appendChild(this.buttonExitCanvas.View());
	
	// 	AddMouseDownListener(button, () => {
	// 		if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {		
	// 			this.Spin();
	// 		}
	// 		else {
	// 			Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
	// 		}
	// 	});
	// }

	// protected PrepareReelsContainer(resourceManager: IReadOnlyResourceManager):void
	// {
	// 	this.reelsContainer = CreateElement("div",{classes:["reelsContainer"], parentToAppend:this.view,
	// 		style:{
	// 			width: Scale.Wpx(1920),
	// 			height: Scale.Wpx(1080),
	// 			display : "flex",
	// 			position : "absolute",
	// 			bottom : "0px"
	// 		}
	// 	})
	// }


	
	protected async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.params.commonBonusResourcesBasePath + "HoldAndSpin.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.params.commonBonusResourcesBasePath + "HoldAndSpin.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		await this.PrepareFonts(resourceManager);
		await this.BackgroundPrepare(resourceManager);

		//resourceManager.Add(new ImageResource(this.params.gamepath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));

		resourceManager.Add(new DecodedImageResource(this.params.gamepath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));


		//resourceManager.Add(new ImageResource(this.params.gamepath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));

		resourceManager.Add(new DecodedImageResource(this.params.gamepath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));

		// //LOAD DIAMOND POT SPRITE		
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));


		//LOAD DIAMOND POT SPRITE		
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));

	}

	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager) {
		//Yo
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background"+Settings.Screens+"S/" +"background.png", this.resid.ScopedResourceName(["background", "image"])));
		//Yo
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void {

		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		//resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	}

	protected gameBackground: string = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		let gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
        this.gameBackground = gameBackground.CssBackground();
		SetStyles(this.backgroundSpinHoldGame, {
			backgroundImage: this.gameBackground,
			backgroundSize: "100%",
		});
	}

	//History view
	protected async PrepareHistory(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		//resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/playLines.css", this.resid.ScopedResourceName("playLines"), this.resid.Add("History").CSSScope()));
	}

	//protected historySpinableReels = null;
	protected historySymbolImg: ImageResource = null;
	protected async LoadedHistory(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		this.historySymbolImg = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["plusone", "image"]));

		// this.historySpinableReels = new S2_SpinnableReels2(
		// 	// TODO window symbol size must come as config from backend
		// 	{ reelConfig: this.config.ReelSet, windowSymbolsSize: new Size(5, 3)}, 
		// 	{ windowRect: this.params.windowRectangle }
		// );

		//this.historySpinableReels = new SpinnableReels(new Size(5, 4), new PixelRect(0, 0, 900, 640));
		// SetStyles(this.historySpinableReels.GetView(),
		// 	{
		// 		position: "static"
		// 	})
	}


	/**
	 *	BIG WIN
	 */
	protected async BigWinPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	protected async BigWinLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		// quit dont need fountain
		let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
		fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation = null;

		let smallfountainAnimation = SlotGameType1Shared.Instance().mediumFountainAnimation;
		smallfountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		smallfountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		smallfountainAnimation = null;

		let bigfountainAnimation = SlotGameType1Shared.Instance().bigFountainAnimation;
		bigfountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		bigfountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		bigfountainAnimation = null;

	}

	/**
	 *	FEATURES
	 *  TODO check what features are actually enabled in freegames!
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/coin.png", this.resid.ScopedResourceName(["plusone", "image"])));
		
		{
			let params: ScatterRandomAwardCreateParams = 
			{
				logGroup: this.logGroup,
				resid: this.resid,
				// reelSet: this.config.ReelSet.map(rs => rs.Symbols),
				availableSymbols: this.params.symbols,
			};

			//let config: ScatterRandomAwardConfiguration[] = Object.values(this.config.MultiFeatureConfiguration).filter(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration[];
			let config = FilterFeatures(this.config.MultiFeatureConfiguration, (f): f is ScatterRandomAwardConfiguration => f.FeatureType == "ScatterRandomAward");

			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, config, this.params.color);
			await this.scatterRandomAwardFeature.PrepareResources(resourceManager);
			config = null;
			params = null;
		}

		{
			// let params: HoldingFeatureParamsPIXI = 
			// {
			// 	logGroup: this.logGroup,
			// 	resid: this.resid,
			// 	spinnableReels: this.spinnableReels2,
			// 	gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			// 	reelsCoverAnotherScreen : false

			// };

			// this.holdingFeature = new HoldingFeaturePIXIApp(params);
			// await this.holdingFeature.PrepareResources(resourceManager);
			// params = null;
			await this.HoldingFeaturePrepare(resourceManager)
		}
	}

	protected async HoldingFeaturePrepare(resourceManager: IWriteOnlyResourceManager){
		let params: HoldingFeatureParamsPIXI = 
		{
			logGroup: this.logGroup,
			resid: this.resid,
			spinnableReels: this.spinnableReels2,
			gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			reelsCoverAnotherScreen : false,
			gameName : this.gameName,
			symbolCollection : this.params.symbolCollection,
			symbolTypeAnim : this.params.gameConfig.symbolsType,
			audio : this.audio,
		};

		this.holdingFeature = new HoldingFeaturePIXIApp(params);
		await this.holdingFeature.PrepareResources(resourceManager);
		this.holdingFeature.holdingFeatureEndCallback=()=>{
			this.NextScatterMultiplier();
		}
		params = null;
	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		{
			await this.scatterRandomAwardFeature.ResourcesLoaded(resourceManager);
		}

		{
			await this.holdingFeature.ResourcesLodaded(resourceManager, this.scatterRandomAwardFeature.GetAwardOptions());
			//this.view.appendChild(this.holdingFeature.View());
			//this.holdingFeature.View().style.display = "none";
		}
	}

	protected async CometsPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// TODO share comets with pickbonus or use separate comets?
		//resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/cometShort", ResourceIdentifier.Global.Add("SpinAndHold").Add("Commet"), true, LogGroup.Global.Add("SpinAndHold").Add("Commet"), true))
		this.commetView = this.commetFactory.CreateCometPIXIAPP(this.audio , this.resid,false,this.params.FpsFactor, this.systemContext, this.gameName);
		await this.commetView.PrepareResources(resourceManager);
	}

	//
	protected skipMessageHide : ITimeout = null;	
	protected skipMessageCommets : HTMLElement = null;	
	protected async SpriteCometsLoaded(resourceManager: IReadOnlyResourceManager){
		//this.comet = new Comet(new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("SpinAndHold").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch}));
        //this.comet.OnCompleteCallback = this.OnCometEnd.bind(this);

		await this.commetView.ResourcesLoaded(resourceManager);
		this.commetView.OnCompleteCallback = this.OnCometEnd.bind(this);
	}

	protected async CometsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.SpriteCometsLoaded(resourceManager);
	}

	

	/**
	 *	REELS
	 */
	public async PrepareBackgroundReel(resourceManager: IWriteOnlyResourceManager): Promise<void> {		
		//this.spinnableReelsParams.backgroundImage = new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel.png", this.resid.ScopedResourceName(["reelFregame", "image"]));
		//resourceManager.Add(this.spinnableReelsParams.backgroundImage);

		// prepare backgrounds
		//need fit GetReels
		let differentBackgrounds: string[] = this.config.SymbolSpanSizes
			// generate name for each reel
			.map(size => size.ColSpan + "x" + size.RowSpan)
			// filter only unique
			.filter(Filter.UniqueItem);

		differentBackgrounds.forEach(reelsize => {
			resourceManager.Add(new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel_" + reelsize + ".png", this.resid.ScopedResourceName(["reelbackground", reelsize])));
			resourceManager.Add(new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reelmask_" + reelsize + ".png", this.resid.ScopedResourceName(["reelbackgroundMask", reelsize])));
		});
	}

	protected async DemoLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (this.params.slotGameMeta.Demo == true) {

			this.view.appendChild(this.demoMessage);
		}
	}

	protected ConstructReelParams(constructReelsParams: ConstructReelsParams)
	{
		
		assertNotNullish(constructReelsParams.ReelSet, "ReelSet must be set when constructing reels");

		if (this.spinnableReels2)
		{
			this.spinnableReels2.Destroy();
		}

		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow
			},
			{
				windowRect: constructReelsParams.WindowRect,
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				backgroundImage : this.params.spinnableReelsParams.backgroundImage,
				
				pixiSpritesByName : this.params.pixiSpritesByName,

			},
			this.systemContext,
			constructReelsParams.Extended
		);

		this.spinnableReels2.OnCreatedCallback = () => {
			this.ReelBackgroundLoaded();
			//this.redrawPixiReels();
		};
	}

	protected reelSpinAnimations:S2_ReelSpinAnimation[] = [];
	protected AspectFixY: number = 1;
	protected playWindow : PlayWindow = null;
	protected ConstructReels2(constructReelsParams: ConstructReelsParams)
	{
		this.AspectFixY = ParseMonitors().AspectFixY;
		{
			// let reelConfig: S2_ReelConfig[] = [
			// 	{Name: "left", Index: 0, Row: 0, Col: 0, ColSpan: 1, RowSpan: 3, Height: 3, Symbols: []},
			// 	// {Name: "left", Index: 0, Row: 0, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "left", Index: 1, Row: 1, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "left", Index: 2, Row: 2, Col: 0, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
		
			// 	{Name: "right", Index: 1, Row: 0, Col: 4, ColSpan: 1, RowSpan: 3, Height: 3, Symbols: []},
			// 	// {Name: "right", Index: 3, Row: 0, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "right", Index: 4, Row: 1, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
			// 	// {Name: "right", Index: 5, Row: 2, Col: 4, ColSpan: 1, RowSpan: 1, Height: 1, Symbols: []},
		
				
			// 	{Name: "center", Index: 2, Row: -3, Col: 1, ColSpan: 3, RowSpan: 6, Height: 2, Symbols: []}
			// ];

			// this.config.ReelSet = reelConfig;

			// update center reel so it is visible 1 symbol above, in the 2. screen
			let centerReel: S2_IReelConfig = constructReelsParams.ReelSet.find(r => r.Name.toLowerCase() == "center");
			if (centerReel)
			{
				if (centerReel.Height != 1) throw "Center reel expected to be 1 symbol high";
				if (centerReel.Row != 0) throw "Center reel expected to start in row 0";
				if (centerReel.RowSpan != constructReelsParams.PlayWindow.Height) throw `Center reel expected have rowspan ${constructReelsParams.PlayWindow.Height}`;

				//centerReel.ExtraSymbolsAbove = 1;
			}


			// this.spinnableReels2 = new S2_SpinnableReels2(
			// 	{
			// 		reelConfig: this.config.ReelSet,
			// 		windowSymbolsSize: new Size(this.config.PlayWindow.Width, this.config.PlayWindow.Height)
			// 	},
			// 	{
			// 		windowRect: this.params.windowRectangle,
			// 		leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
			// 		rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
			// 		topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
			// 		bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
			// 	}
			// );

			this.ConstructReelParams(constructReelsParams);

			//let reelSpinAnimations: S2_ReelSpinAnimation[] = [];
			let animationColumns: number[] = this.spinnableReels2.GetAnimationColumns();
			animationColumns.forEach((animationColumn, animationColumnIndex) => {

				


				let symbolHeight = this.spinnableReels2.GetSymbolSizePixels2(animationColumnIndex, 0).Height;

				// // speed correction
				// const someReel = this.config.ReelSet.filter(r => r.Col == animationColumn)[0];
				// let speedCorrection = someReel.Height / someReel.RowSpan;

				// // old speed correction
				// let oldSpeedCorrection = this.spinnableReels2.GetOriginalSymbolSize().height / this.spinnableReels2.GetWindowSize().height;

				// console.log(`${this.logGroup.Name} column ${animationColumn}(${animationColumnIndex}) new speed correction ${speedCorrection * 0.125}   height ${someReel.Height} span ${someReel.RowSpan}`);
				// console.log(`${this.logGroup.Name} column ${animationColumn}(${animationColumnIndex}) old speed correction ${oldSpeedCorrection * 0.65} symbol ${this.spinnableReels2.GetOriginalSymbolSize().height} window ${this.spinnableReels2.GetWindowSize().height}`);


				let params:S2_ReelSpinAnimParams = {
					logGroup: this.logGroup,
					columnIndex: animationColumnIndex,
					symbolHeightInPixels: symbolHeight,
					overshootHeightInSymbols: 0.125 * symbolHeight,
					deccelerationHeightInSymbols: this.spinnableReels2.GetMaxReelHeightInSymbols() +1,
					speedCorrection: 0.90*0.30, //speedCorrection * 0.125,
					delay: 400
				};
		
				let reelSpinAnimation = new S2_ReelSpinAnimation(params);
				this.reelSpinAnimations.push(reelSpinAnimation);


				reelSpinAnimation.AddOnUpdateCallback(this.ReelColumnUpdate.bind(this));


				reelSpinAnimation.AddOnStartCallback((anim) => {
					let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for (let r = 0; r < reelsToAnimate.length; r++) {
						let reelToAnimate = reelsToAnimate[r];
						let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
						reelMapper.Start();

						reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
						//reelToAnimate.SpinMaskElement.style.overflow = "hidden";
						reelToAnimate.TopHiddenSymbols.visible = true;
						reelToAnimate.BottomHiddenSymbols.visible = true;
						reelMapper = null;
						reelToAnimate = null;
						//reelToAnimate.ReelWindowElement.style.overflow = "hidden";
					}
				});

				reelSpinAnimation.AddOnDeccelerationCallbak((anim, params) => {
					let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for (let r = 0; r < reelsToAnimate.length; r++) {
						let reelToAnimate = reelsToAnimate[r];
						let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
						let distanceInSymbols = params.totalDistanceInSymbols;
						reelMapper.Slice(distanceInSymbols);
						distanceInSymbols = null;
						reelMapper = null;
						reelToAnimate = null;

					}
                });
                
                reelSpinAnimation.AddOnNearCompleteCallback((anim) => {
					this.OnReelStopped();
					let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for (let r = 0; r < reelsToAnimate.length; r++) {
						let reelToAnimate = reelsToAnimate[r];

						reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
						reelToAnimate = null;
						//reelToAnimate.SpinMaskElement.transform.overflow = "";
					}

					//does this column contain any reel Spinning?
					let anyReelSpinning = !this.session.HoldReels || reelsToAnimate.filter(r => !this.session.HoldReels[r.Config.Index]).length > 0;
					if (anyReelSpinning) {
						this.audio.Play(this.parentresid.ScopedResourceName("reelstop"));
					}
					//does this column contain reel with big symbol?
					let columnContainsBigReel = reelsToAnimate.filter(r => r.Config.ColSpan > 1).length > 0;
					if (columnContainsBigReel) {
						this.audio.Play(this.resid.ScopedResourceName("bigreelSpinStop"));
					}
					reelsToAnimate = null;
                });

				reelSpinAnimation.AddOnCompleteCallback((anim) => {
					let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

					for (let r = 0; r < reelsToAnimate.length; r++) {
						let reelToAnimate = reelsToAnimate[r];

						reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
						//reelToAnimate.SpinMaskElement.style.overflow = "";
						reelToAnimate.TopHiddenSymbols.visible = false;
						reelToAnimate.BottomHiddenSymbols.visible = false;
						//reelToAnimate.ReelWindowElement.style.overflow = "";
						reelToAnimate = null;
					}
					reelsToAnimate = null;
				})
			});

			this.spinAnimation2 = new S2_SpinAnimation(this.logGroup, constructReelsParams.ReelSet, this.reelSpinAnimations);
			this.spinAnimation2.AddOnCompleteCallback(() => {
				this.SpinComplete();
				this.audio.Stop(this.parentresid.ScopedResourceName("anticipation"));
				this.stateMachine.ChangeState(SpinAndHoldState.Features);
			});

			// if (Settings.touchToStop == true) {
			// 	AddMouseDownListener(this.gameViewApp.view, () => {
			// 		this.spinAnimation2.RequestStop();
			// 	});
			// }
		}


		this.reelSetMapper2 = new S2_ReelSetMapper(constructReelsParams.PlayWindow, this.logGroup);
		constructReelsParams.ReelSet.forEach((reelConfig, reelIndex) => {
			let m: S2_ReelMapper = new S2_ReelMapper(reelIndex, this.logGroup, reelConfig.Height, this.spinnableReels2.GetReelDisplayGeometry(reelIndex));
			
			// TODO add start position?
			// TODO add extended symbols?
			m.SetReel(reelConfig.Symbols, reelConfig.StartPosition || 0);
			this.reelSetMapper2.AddReelMapper(m);
		});

		this.currentSymbols = this.reelSetMapper2.GetSymbols2();

		this.playWindow = constructReelsParams.PlayWindow;
	}


	protected reelBackgroundMap: Map<string, DecodedImageResource> = new Map<string, DecodedImageResource>();
	protected reelBackgroundMaskMap: Map<string, DecodedImageResource> = new Map<string, DecodedImageResource>();
	protected async ReelsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{	
		// this.spinnableReels2.OnCreatedCallback = () => {
		// 	this.ReelBackgroundLoaded();
		// 	this.redrawPixiReels();
		// };

		let differentBackgrounds: string[] = this.config.SymbolSpanSizes
		// generate name for each reel
		.map(size => size.ColSpan + "x" + size.RowSpan)
		// filter only unique
		.filter(Filter.UniqueItem);

		differentBackgrounds.forEach(backgroundSize => {			
			let imgResource: DecodedImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelbackground", backgroundSize]));
			this.reelBackgroundMap.set(backgroundSize, imgResource);

			let imgResourceMask: DecodedImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelbackgroundMask", backgroundSize]));
			this.reelBackgroundMaskMap.set(backgroundSize, imgResourceMask);
		});
	}


	protected ReelBackgroundLoaded() {		
		let reels = this.spinnableReels2.GetReels();

		
		
		for (let reel of reels)
		{
			let backgroundSize = reel.Config.ColSpan + "x" + reel.Config.RowSpan;	
			
			//BackgroundReel DecodeImage
			let imgResource: DecodedImageResource = this.reelBackgroundMap.get(backgroundSize);
			let backgroundReelTexture = PIXI.Texture.from(imgResource.DecodedImage());

			let scaleWidth = reel.BackgroundRect_pixels.width / backgroundReelTexture.width;
			let scaleHeight =  reel.BackgroundRect_pixels.height / backgroundReelTexture.height
			let scale = Math.min(scaleWidth, scaleHeight);
			backgroundReelTexture.baseTexture.width = backgroundReelTexture.width * scale;
			backgroundReelTexture.baseTexture.height = backgroundReelTexture.height * scale;

			reel.WindowBackgroundElement.texture = backgroundReelTexture;

			//backgroond reel Mask DecodeImage
			let imgResourceMask: DecodedImageResource = this.reelBackgroundMaskMap.get(backgroundSize);
			let backgroundReelMaskTexture = PIXI.Texture.from(imgResourceMask.DecodedImage());

			let scaleWidthMask = reel.BackgroundRect_pixels.width / backgroundReelMaskTexture.width;
			let scaleHeightMask =  reel.BackgroundRect_pixels.height / backgroundReelMaskTexture.height
			let scaleMask = Math.min(scaleWidthMask, scaleHeightMask);
			backgroundReelMaskTexture.baseTexture.width = backgroundReelMaskTexture.width * scaleMask;
			backgroundReelMaskTexture.baseTexture.height = backgroundReelMaskTexture.height * scaleMask;

			reel.SpinMaskElement.texture = backgroundReelMaskTexture;	
			
			


			// //old way load pixi background Texture
			// let textureBackgroundReel = PIXI.Texture.from(this.params.gameBonusResourcesBasePath + "reel_" + backgroundSize + ".png");
			// reel.WindowBackgroundElement.texture = textureBackgroundReel;		

			// let textureMaskReel = PIXI.Texture.from(this.params.gameBonusResourcesBasePath + "reelmask_" + backgroundSize + ".png");
			// reel.SpinMaskElement.texture = textureMaskReel;		
			
			imgResource = null;
			backgroundReelTexture = null;

			imgResourceMask = null;
			backgroundReelMaskTexture = null;
		};
	}

	protected ReelColumnUpdate(params: Readonly<S2_ReelSpinAnimationUpdateParams>): void {
		let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(params.reelSpinAnimation.ColumnIndex);

		for (let r = 0; r < (reelsToAnimate?.length ?? 0); r++) {
			let reelToAnimate = reelsToAnimate[r];

			// Don't animate when holding
			if (this.session.HoldReels &&
				this.session.HoldReels[reelToAnimate.Config.Index] >= 0
			) {
				continue;
			}

			if (reelToAnimate?.ReelElement?.transform)
			{
				reelToAnimate.ReelElement.transform.position.y = params.modSymbolDistance;
			}

			let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
			reelMapper.Update(params.symbolDistance);

			if (reelMapper.DidSymbolsChange()) {
				this.currentSymbols[reelToAnimate.Config.Index] = reelMapper.GetSymbols2();

				for (let rowIndex: number = 0; rowIndex < reelToAnimate.ReelDisplayGeometry.symbolsTotal; rowIndex++) {
					this.DrawSymbol(reelToAnimate.Config.Index, rowIndex);
				}
			}
		}
	}

	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	public DrawSymbol(reelIndex: number, rowIndex: number): void {
		

		let canvasPIXI = this.spinnableReels2.pixiCanvas?.[reelIndex]?.[rowIndex];
		if (!canvasPIXI)
		{
			// no canvas to use
			return;
		}


		let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
		let symbol: SlotSymbol = this.params.symbols[symbolToDisplay.symbolIndex];

		

		//canvasPIXI.parent.children.forEach(ele => ele.name == "Spine" ? ele.destroy({children : true}) : false);
		if (symbol.ID == this.requiredSymbol) {
			let symbolPack = this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID)
			let img = PIXI.Texture.from(symbolPack.imgResource);

			let scaleWidth = this.spinnableReels2?.GetSymbolSize().Width / img.width;
			let scaleHeight = this.spinnableReels2?.GetSymbolSize().Height / img.height
			let scale = Math.min(scaleWidth, scaleHeight);
			canvasPIXI.scale.set(scale, scale * this.AspectFixY);
			
			canvasPIXI.texture = img;
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI as PIXI.AnimatedSprite,null, symbolPack.showAward);
			symbolPack = null;
			img = null;
			scaleWidth = null;
			scaleHeight = null;
			scale = null;
		}
		//use for normal symbol 
		else {
			let symbolPack = this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID)
			let img = PIXI.Texture.from(symbolPack.imgResource);

			let scaleWidth = this.spinnableReels2?.GetSymbolSize().Width / img.width;
			let scaleHeight = this.spinnableReels2?.GetSymbolSize().Height / img.height
			let scale = Math.min(scaleWidth, scaleHeight);
			canvasPIXI.scale.set(scale, scale * this.AspectFixY);
			canvasPIXI.texture = img;
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI as PIXI.AnimatedSprite, null, symbolPack.showAward);
			symbolPack = null;
			img = null;
			scaleWidth = null;
			scaleHeight = null;
			scale = null;
		}
	}

	public Confirm(): void {
		if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
			// Log.Debug(this.logGroup, "Intro message confirmed");		
			this.introMessageContainerPIXIAPP.visible = false;	
			this.stateMachine.ChangeState(SpinAndHoldState.MultiplierShow);
		}
		else if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
			// Log.Debug(this.logGroup, "Final message confirmed");
			this.ShowVideoTransition();					
		}
		else {
			Log.Error(this.logGroup, "Can't confirm message, current state: " + SpinAndHoldState[this.stateMachine.State()]);
		}
	}
	public Spin(): void {

		// Log.Debug(this.logGroup, "Spin");

		switch (this.stateMachine.State()) {
			//case SpinAndHoldState.Running:

			// when in idle state, spin starts new spin
			case SpinAndHoldState.SpinIdle:
			case SpinAndHoldState.WaitFirstSpin:

				// make sure to clear timer, to prevent double spin??
				if (this.session.RunsRemaining > 0) {

					// Log.Debug(this.logGroup, "Spin: Requesting next spin");

					if (this.autoSpinTimer != null) clearTimeout(this.autoSpinTimer);
					this.spinInterrupted = false;

					this.spinAnimation2.Start();					

					// TODO
					// protocol.Send("BonusNextRun", null);
					this.stateMachine.ChangeState(SpinAndHoldState.Spin);
				}
				break;
			case SpinAndHoldState.FinalMessage:
			case SpinAndHoldState.IntroMessage:
				if (this.stateMachine.TimeSinceLastStateChange() > 500) {
					// Log.Debug(this.logGroup, "Spin: Confirming message");
					this.Confirm();
				}
				break;

			case SpinAndHoldState.Spin:
				// Log.Debug(this.logGroup, "Spin: Request spin stop");
				this.spinAnimation2.RequestStop(-1);
				break;

			case SpinAndHoldState.Features:
				// Log.Debug(this.logGroup, "Spin: Request features stop");
				this.RequestFeatureStop();
				break;

			case SpinAndHoldState.CometCollect:
				// only skip if enabled in settings
				if (false && Settings.skipCommet == true) {

					//console.log(`Skipping commet ${this.currentScatterCometIndex} of ${this.scatterPositions.length}`);

					if (this.currentScatterCometIndex != -1 &&
						this.currentScatterCometIndex < this.scatterPositions.length &&
						this.stateMachine.TimeSinceLastStateChange() > 2000) {

						if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.AwardOption.AwardType == AwardType.BetMultiplier) {
							//this.skipMessageCommets.style.display = "flex";
							this.skipCometMessageContainer.visible = true;
							//this.skipCometMessageContainer.alpha = 1;

							this.skipMessageHide.Start();
							if (this.isShowed == false) {
								this.OnCometEnd();
							}
							this.RequestStopsCommetShowWin();
							this.NextComet();
						} else if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot) return

					}
				}
				break;


			// When in win state, spin interrupts the count
			case SpinAndHoldState.Win:
				// Log.Debug(this.logGroup, "Spin: Request win stop");
				this.spinInterrupted = true;
				//this.winLinesAnimation.RequestStop();
				break;

			default:
				// Log.Debug(this.logGroup, "Spin: Nothing to do in current state: " + this.stateMachine.StateName);
				break;
		}
	}

	public AutoSpin(): void {
        if (this.params.bonusAutoplay && !this.isLocked)
        {
            // Log.Debug(this.logGroup, "Autospin");
            this.Spin();
        }
        else
        {
            // autospin disabled
        }
	}

	// TODO change, remove, improve
	public Reset(): void {
		this.lastSpinResult = null;
	}

	private SpinComplete(): void {
	}

	// protected RedrawCanvasButton()
	// {
	// 	this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
	// 	this.SetTextCanvas(this.translator.t.freegameExit,  this.buttonExitCanvas);
	// }

	protected HideHoldingReels() {
		this.spinnableReels2.GetReels().forEach(r => {

			if (this.session.HoldReels[r.Config.Index] >= 0) {
				//SetStyles(r.ReelElement, {display: "none"});
				r.ReelElement.visible = false;
			}
			else {
				//SetStyles(r.ReelElement, {display: ""});
				r.ReelElement.visible = true;
			}
		});
	}


	public Start(): void {

		// Log.Debug(this.logGroup, "Bonus started");

		//fix
		//this.RedrawCanvasButton();
		//this.basegameWinCents = basegameWinCents;

		this.lastSpinResult = null;
		this.session.Reset();
		this.session.RunsPlayed = 0;
		this.session.RunsStarted = this.startAction.SpinsStarted;
		this.session.RunsRemaining = this.startAction.SpinsRemaining;

		let scatterData = this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown  as ScatterRandomAwardResults;

		this.session.ScattersDisplayed = scatterData &&
		scatterData.ScattersTotal || 0;

		if(this.winCountTextPIXIAPP != null) this.winCountTextPIXIAPP.text = this.session.ScattersDisplayed;
		if(this.spinRemainingTextPIXIAPP != null) this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining;

		this.session.HoldReels = this.startAction.HoldReels;

		// hide holding reels on start, because they might show different symbols
		// and if HoldingFeature is covering symbol, the symbol might peek out
		this.HideHoldingReels();
		
		//this.stateMachine.ChangeState(SpinAndHoldState.IntroMessage);
		this.stateMachine.ChangeState(SpinAndHoldState.IntroTransition);

		//this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);

		// Log.Debug(this.logGroup, "Bonus started");

		//this.Show();

		//this.PanelRequired(false);

		this.messageContainerPIXIAPP.visible = true;
		this.introMessageContainerPIXIAPP.visible = true;
		this.introMessageContainerPIXIAPP.interactiveChildren = true;	
		this.introMessageContainerPIXIAPP.interactive = true;	
		

		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));

		// TODO use different message for start instead of SPIN
		//this.screenProtocol?.Send(new SpinAndHoldMessages.SpinMessage(this.session), this.screenProtocolScope);
		
		// assertNotNullish(this.spinRemainingTextPIXIAPP);
		// if(this.spinRemainingTextPIXIAPP != null)
		// {
		// 	this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining;
		// }

		// assertNotNullish(this.winCountTextPIXIAPP);
		// if(this.winCountTextPIXIAPP != null)
		// {
		// 	this.winCountTextPIXIAPP.text = this.session.ScattersDisplayed;
		// }


		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents));
	}


	public Show() {
		this.view.style.display = "block";
	}

	public Hide() {
		this.view.style.display = "none";
	}



	public Update(): void {	

		if (!this.created)
		{
			// bonus not created yet or already destroyed
			return;
		}

		this.spinAnimation2.Update();	
		this.holdingFeature.Update();
		this.commetView.Update();
		//this.transitionView.Update();

		this.scatterRandomAwardFeature.Update();

		// check canvases
		for (let reelIndex = 0; reelIndex < this.spinnableReels2.canvas.length; reelIndex++)
		{
			for (let rowIndex = 0; rowIndex < this.spinnableReels2.canvas[reelIndex].length; rowIndex++)
			{
				if (this.spinnableReels2.canvas[reelIndex][rowIndex].WasContextLost())
				{
					this.DrawSymbol(reelIndex, rowIndex);

					this.spinnableReels2.canvas[reelIndex][rowIndex].RestoreContext();
				}
			}
		}
		//fix
		// if (this.buttonStartCanvas.WasContextLost() ||
		// 	this.buttonExitCanvas.WasContextLost())
		// {
		// 	this.RedrawCanvasButton();
		// }
	}

	public View(): HTMLElement {
		return this.view;
	}

	public GetSession(): GameSession {
		return this.session;
	}	

	protected started:boolean=false;
	
	public ShowVideoTransition() {
		if (this.started == false) {
			this.transitionView.ShowTransiton();
			this.started = true;
		}
	}

	

	protected OnTransitionStarted() {
		this.audio.Play(this.resid.ScopedResourceName("transitionaudio"));	
		this.started = true;
	}

	protected OnTransitionEnded(): void {
		this.started = false;
		if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
			this.stateMachine.ChangeState(SpinAndHoldState.Idle);
		} else {
			this.stateMachine.ChangeState(SpinAndHoldState.IntroMessage);
		}
	}

    protected OnIntroTransitionBegin(): void
    {		
		this.PanelRequired(true);
    }

    protected OnIntroTransitionEnd(): void
    {

    }

	protected OnIntroMessageBegin(): void {
		this.robotPlay.BonusConfirm("IntroMessage");
	}

	private OnIntroMessageEnd(): void {
		//this.introMessageContainer.style.display = "none";
		this.robotPlay.BonusConfirmAccepted();
	}

	public OnPicked(index: number): void {
	}

	protected triggerStartSoundLoop: ITimeout;
	protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(loop : number , delay : number = 1000): void {		
		//let delay: number = 1000;
		for (let i = 0; i < loop; i++) {
			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("triggered")), delay * (i + 1));
		}
	}

	public override TriggerAnimationStartedSpine(): void {		
		this.audio.Play(this.resid.ScopedResourceName("triggered"));		
	}

	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));				
	}

	private OnWaitFirstSpinBegin(): void {
		//this.HideAllContainers();
		//this.ShowContainer(SpinAndHoldContainer.Reels);
		//this.HideContainer(SpinAndHoldContainer.IntroMessage);	
		//this.dialogContainerApp.visible = false;	
		this.messageContainerPIXIAPP.visible = false;
		this.introMessageContainerPIXIAPP.visible = false;
		this.timeoutAutoSpin.Start();
	}

	protected OnSpinBegin(): void {
		this.session.RunsRemaining--;
		this.session.RunsPlayed++;

		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));

		//this.screenProtocol?.Send(new SpinAndHoldMessages.SpinMessage(this.session), this.screenProtocolScope);

		//assertNotNullish(this.spinRemainingTextPIXIAPP);
		this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining;


		// setTimeout(()=>{
		// 	this.winCountTextPIXIAPP.text = this.session.ScattersDisplayed;
		// },3500);
		
		this.OnSimpleSpinRunResult();
	}

	

	private OnReelStopped(): void {
		//this.grayScale.Start(reelIndex);
		this.audio.Play(this.parentresid.ScopedResourceName("reelstop"));
	}

	private OnSpinEnd(): void {
		this.audio.Stop(this.parentresid.ScopedResourceName("leverpull"));
		this.session.HoldReels = this.simpleLastBonusAction.HoldReels;		
	}

	//protected currentFeature: SlotFeature = null;



	protected OnFeaturesBegin(): void {
		// do we have any features that triggered?

		this.session.RunsRemaining = this.simpleLastBonusAction.SpinsRemaining;
		this.session.RunsPlayed = this.simpleLastBonusAction.SpinsPlayed;
		let ScatterRandomAward = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		this.session.ScattersDisplayed = ScatterRandomAward.ScattersTotal;

		// assertNotNullish(this.winCountTextPIXIAPP);
		if(this.winCountTextPIXIAPP != null) this.winCountTextPIXIAPP.text = this.session.ScattersDisplayed;
		//this.currentFeature = null;
		
		if (ScatterRandomAward.ScattersAddedThisSpin > 0) {		
			this.audio.Play(this.resid.ScopedResourceName("bounceSound"));	
			this.holdingFeature.Start(ScatterRandomAward.ScattersPositionThisSpin, this.startAction.Multiplier , this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").showAward);			
			this.timeoutSRAPlusOne.Start();
		}
		else {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
		}
	}

	protected RequestFeatureStop(): void {
		// if (this.currentFeature != null) {
		// 	this.currentFeature.RequestStop();
		// 	//this.symbolsAnimation.Update();
		// }
	}

	protected OnFeaturesEnd(): void {
		//this.currentFeature = null;
		this.HideHoldingReels();
	}



	// public FeatureFinished() {
	// 	// next feature, or continue to big win
	// 	this.currentFeatureIndex++;

	// 	if (this.currentFeatureIndex >= this.lastSpinResult.FeatureResults.length) {
	// 		this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
	// 	}
	// 	else {

	// 		for (; this.currentFeatureIndex < this.lastSpinResult.FeatureResults.length; this.currentFeatureIndex) {
	// 			if (this.lastSpinResult.FeatureResults[i].)
	// 		}
	// 	}
	// }

	private OnBigWinBegin(): void {


		//// Log.Debug(this.logGroup, "Big win message will not show");
		//this.stateMachine.ChangeState(SpinAndHoldState.Win);
		this.stateMachine.ChangeState(SpinAndHoldState.Win);

	}

	private OnBigWinEnd(): void {
	}


	private OnWinBegin(): void {
		this.stateMachine.ChangeState(SpinAndHoldState.Collect);
	}


	private OnWinEnd(): void {
	}

	// private OnLinesComplete(interrupted: boolean): void {
	// 	//this.winLineMarkers.Hide();
	// 	this.stateMachine.ChangeState(SpinAndHoldState.Collect);
	// }

	protected OnCollectBegin(): void {

		this.stateMachine.ChangeState(SpinAndHoldState.SpinIdle);
		//this.screenProtocol?.Send(new FreegameMessages.WinInterruptedMessage(), this.screenProtocolScope);
		//this.indexsimpleLastSpinAction++;
		this.panel.SetMessage(this.translator.t.goodluck);
	}

	public NextBonusEnd() 
	{
		throw "Not implemented"

		// if(this.lastSpinResult.NextBonus != null)
		// {
		// 	this.lastSpinResult.TotalWin += bonusWin;

		// 	this.session.win = bonusWin;
		// 	this.session.totalWin = this.lastSpinResult.TotalWin;
		// 	this.session.winDuration = 1;
		// 	this.panel.SetWin(this.moneyFormatter.FormatCredit(this.lastSpinResult.TotalWin), this.moneyFormatter.FormatCurrency(this.lastSpinResult.TotalWin));
		// 	this.screenProtocol?.Send(new FreegameMessages.WinMessage(this.session),this.screenProtocolScope);

		// 	this.stateMachine.ChangeState(SpinAndHoldState.SpinIdle);
		// }
		// else
		// {
		// 	Log.Error(this.logGroup, "no next bonus");
		// }


	}


	protected OnSpinIdleBegin(): void
	{

		this.panel.OnIdleBegin();

		if (this.session.RunsRemaining > 0)
		{
			// TODO this bonus must auto spin
			// // put some delay before next spin
			if (this.spinInterrupted)
			{
				this.AutoSpin();
			}
			else
			{
				this.autoSpinTimer = window.setTimeout(() => this.AutoSpin(), 1000);
			}
		}
		else
		{
			// put some delay before final message
			//this.screenProtocol?.Send(new SpinAndHoldMessages.StartShowWin2Screen, this.screenProtocolScope);			

			//this.bonunsGameInfoStats.visible = false;		
			this.timeoutStartCometCollect.Start();
		}
	}

	
	protected StartShowWin(jp: JackpotLevel, timerShow: number , award : Money) {
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		//let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp));
		let winJackpot : SharedJackpotWin = {
			JackpotLevel: jp,
			WinAmount: award,
			BetCents: undefined,
			TotalBetCents: undefined,
			TotalJackpotAmount: undefined
		}
		this.jackpotSharedShow?.ShowShared(winJackpot);
		this.awardJPShowPIXIAPP.SetSkin(jp);
		this.awardJPShowPIXIAPP.StarAnim();
		gsap.set(this.awardJPShowPIXIAPP.ViewPIXIAPP(), { alpha: 0 });
		this.awardJPShowPIXIAPP.ViewPIXIAPP().visible = true;
		gsap.to(this.awardJPShowPIXIAPP.ViewPIXIAPP(), { alpha: 1, duration: 0.5 });

		SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.Start(this.resid);

		this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));
		
		gsap.to(this.awardJPShowPIXIAPP.ViewPIXIAPP(), {
			delay: Math.max(0, (timerShow - 700 ) / 1000),
			alpha: 0,
			duration: 0.5, onComplete: () => { 
				this.awardJPShowPIXIAPP.StopAnin();
				this.audio.Stop(this.resid.ScopedResourceName("clasploop"));
				this.StopFontain(jp);
				winJackpot = null;
			}
		});
	}

	protected StopFontain(jp: JackpotLevel) {
		this.audio.Stop(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Stop(this.resid.ScopedResourceName(jp + "Voice"));
		//this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.RequestStop(this.resid);
	}


	private OnSpinIdleEnd(): void {
		this.panel.Stop();
		//console.log('lastIndex:',this.indexsimpleLastSpinAction)
		//this.indexsimpleLastSpinAction++;
		//console.log('nextIndex:',this.indexsimpleLastSpinAction)

	}

	protected WinCountShow() {
		//Hide multiplier 
		this.bonusMultiplier?.Hide();
		// Hide the container using GSAP
		if (this.bonusGameInfoStats != null) gsap.to(this.bonusGameInfoStats, { alpha: 0, duration: 1 });
		//show container win awward using GSAP
		if (this.bonusGameAwardViewPIXIAPP != null) {
			let xPosition = 0;
			if (Settings.Screens != 3 && this.bonusName == "SpinAndHold" || Settings.Enable2plus1 == true && this.bonusName == "SpinAndHold") {
				xPosition = Scale.X(283);
				if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S)
					xPosition = Scale.X(1009)
			}

			gsap.to(this.bonusGameAwardViewPIXIAPP, { x: xPosition, duration: 1, ease: Elastic.easeOut.config(0.50, 0.4) });
		}
	}

	protected OnCometCollectBegin(): void {
		
		
		this.currentScatterCometIndex = -1;

		let ScatterAwards = this.simpleEndSpinAction;
		
		this.scatterPositions = ScatterAwards.Awards;
		this.scatterPositions = this.scatterPositions.sort((a, b) => {

            if (a.AwardOptionPosition.Row > b.AwardOptionPosition.Row) return 1;
			if (a.AwardOptionPosition.Row < b.AwardOptionPosition.Row) return -1;

			if (a.AwardOptionPosition.Col > b.AwardOptionPosition.Col) return 1;
			if (a.AwardOptionPosition.Col < b.AwardOptionPosition.Col) return -1;

			return 0;
		});

		

		// add full award to the beginning, so it starts first
		if (ScatterAwards.FullAward)
		{
			this.scatterPositions.unshift({
				AwardOptionPosition: {
					AwardOption: ScatterAwards.FullAward.AwardOption,
					Col: -1,
					Reel: -1,
					ReelOffset: -1,
					ReelPosition: -1,
					Row: -1,
					ColSpan : -1,
					RowSpan : -1,
				},
				Value: ScatterAwards.FullAward.Value
			});
		}		
		this.commetView.CreatePIXIAPP(this.scatterPositions , this.spinnableReels2);
		this.containerBonusViewApp.addChild(this.commetView.ViewPIXIAPP());


		this.WinCountShow();
		//this.NextComet();
		let jackpotsToReset = this.simpleEndSpinAction.WinAmounts.SequentialProgressiveNonProgressiveWins.map(w => w.Level).filter((p,i,arr)=>arr.indexOf(p) == i);
		this.screenProtocol?.Send(new JackpotValuesReset(jackpotsToReset), new ScreenProtocolScope(["SlotGame", this.gameName]));		
		//this.timeoutNextCommetCash.Start();
		setTimeout(()=>{
			this.NextComet()
		},1000);
	}

	protected winAwardBonus = 0
	protected SendWinInfo(win: number , jp? : JackpotLevel) {
		//this.screenProtocol?.Send(new SpinAndHoldMessages.WinValue(win), this.screenProtocolScope);	
		//missing send money formated
		this.winAwardBonus += win;
		this.containerValueWinAwardText.text = service.moneyFormatter.FormatCurrency(this.winAwardBonus);			
		// if(jp != null) this.jackpotSharedShow?.SetAward(jp,win);

		if (jp != null)
		{

			// find jackpot award index from all award indexes
			let jackpotAwardIndex = -1;
			for (let i = 0; i <= this.currentScatterCometIndex; i++)
			{
				if (this.scatterPositions[i].AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot)
				{
					jackpotAwardIndex++;
				}
			}

			// eslint-disable-next-line @typescript-eslint/no-floating-promises
		    void service.api.jackpothitRequest({
				Amount: win,
				JackpotLevel: jp,
				HitIndex: jackpotAwardIndex
			});



		}
	}

	protected NextComet() 
	{
		//return; 
		this.InternalNextComet();
	}


	protected InternalNextComet() 
	{
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length)
		{
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents))				
			this.timeoutFinalMessageState.Start();					
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
			}
		}
	}

	protected DestinationComet():Point
	{
		if (Settings.Screens == 2){ 
			if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S){
			return new Rect(Scale.X(400), Scale.Y(600), Scale.W(996), Scale.H(147)).Center();
			}
			else {
				return new Rect(Scale.X(54), Scale.Y(896), Scale.W(996), Scale.H(147)).Center();
			}
		}

		if (Settings.Screens == 3)
		{
			if (Settings.Enable2plus1 == true)
			{
				return new Rect(Scale.X(54), Scale.Y(1976), Scale.W(996), Scale.H(147)).Center();
			}
			else
			{
				return new Rect(Scale.X(59), Scale.Y(1670), Scale.W(1817), Scale.H(273)).Center();
			}
		}

		throw new Error(`DesinationComet not implemented for ${Settings.Screens}`);
	}

	protected CometShowtime(awardOptionPosition: AwardPositionWithValue)
	{

		console.log(`CometShowtime index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, awardOptionPosition);
		
		// destination is center of top screen?
		//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
		
		// start comet, if position exists?
		if (awardOptionPosition.AwardOptionPosition.Reel != -1 && awardOptionPosition.AwardOptionPosition.ReelOffset != -1)
		{
			// Log.Debug(this.logGroup, `Showing comet ${this.currentScatterCometIndex}/${this.scatterPositions.length}`);

			// source is center of scatter
			let symbolRect = this.spinnableReels2.GetAbsoluteSymbolRectReelRow(awardOptionPosition.AwardOptionPosition.Reel, awardOptionPosition.AwardOptionPosition.ReelOffset);
			let source: Point = symbolRect.Center();

			// destination is center of top screen?
			//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
			let destination = this.DestinationComet();
			this.commetView.Start(source, this.DestinationComet() , this.currentScatterCometIndex);
			this.PlayCometSound()
		}
		else {
			
			let genericAwardOption = awardOptionPosition.AwardOptionPosition.AwardOption;
			if (genericAwardOption.AwardType == AwardType.Jackpot) {
				this.OnCometEnd();
			}
		}
	}

	protected PlayCometSound() {
		this.commetView.PlayCometSound();
	}
	//protected TotalAwards: number = 0;
	protected isShowed = false;	
	protected OnCometEnd(): void {

		const Awards = this.scatterPositions[this.currentScatterCometIndex];
		const awardOption = Awards?.AwardOptionPosition.AwardOption;

		console.log(`OnCometEnd index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, Awards);
		//let JPAward = this.simpleEndSpinAction.find(b=>b.Phase == "End").WinSinceBonusStart.SequentialProgressiveNonProgressiveWins;
		//let awardJPOption = Awards.AwardOptionPosition.AwardOption;




		this.spineBonusTitleAward?.state?.setAnimation(0, "anim", false);
		this.spineWinAward?.state?.setAnimation(0, "anim", false);
		// start showtime for cash or jackpot
		if (awardOption.AwardType == AwardType.BetMultiplier ||
			awardOption.AwardType == AwardType.Credit
		) {
			this.SendWinInfo(Awards.Value.InCents, null);
			//this.timeoutNextCommetCash.Start();
			this.isShowed = true;
			this.NextComet();

		}
		else if (awardOption.AwardType == AwardType.Jackpot) {

			const jackpotAwardOption: JackpotAwardOption = awardOption as JackpotAwardOption;

			if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared)
				if ( this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
			this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2) this.bonusGameAwardViewPIXIAPP.visible = false;

			this.SendWinInfo(Awards.Value.InCents, jackpotAwardOption.JackpotLevel);
			this.audio.Play(this.resid.ScopedResourceName("clasploop"));

			let jackpotShowDuration = 0 ;
			if (this.jackpotSharedShow != null)
			{
				jackpotShowDuration = this.jackpotSharedShow?.GetDuration(jackpotAwardOption.JackpotLevel)
			}
			else
			{
				jackpotShowDuration = JackpotShowtimeDuration[jackpotAwardOption.JackpotLevel];
			}

			assertNotLess(5000, jackpotShowDuration, "jackpotShowtimeDuration should have some minimum duration");

			this.StartShowWin(jackpotAwardOption.JackpotLevel, jackpotShowDuration, Awards.Value);

			if (Awards.AwardOptionPosition.AwardOption.AwardName == JackpotLevel.Jp4)
			{
				// eslint-disable-next-line @typescript-eslint/no-floating-promises
			    void service.api.jpShowStart({
					jackpotName: jackpotAwardOption.JackpotLevel,
					duration: 55000,
					win: Awards.Value.InCents,
				});
			}
			
			this.isShowed = false;

			
			

			setTimeout(() => {
				this.StopFontain(Awards.AwardOptionPosition.AwardOption.AwardName as JackpotLevel);
				
					if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
						this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2)
					{
						this.bonusGameAwardViewPIXIAPP.visible = true;
					}
				

				if (this.jackpotSharedHit != null) {
					this.jackpotSharedShow?.ShowShared(this.jackpotSharedHit);					
					setTimeout(() => {
						this.jackpotSharedHit = null;
						this.NextComet();						
					}, this.jackpotSharedShow?.GetDuration(this.jackpotSharedHit.JackpotLevel) + 500)
				}
				else {
					this.NextComet()
				}
			}, jackpotShowDuration + 500)
		}
	}

	protected OnCometCollectEnd(): void {
		//stops all intervals commets
		//this.RequestStopsCommetShowWin();
		this.commetView.ViewPIXIAPP().visible = false;

	}

	protected RequestStopsCommetShowWin() {
		// Log.Debug(this.logGroup, "Spin: Request stops commets");		
		this.commetView.StopsCommets()			
		this.commetView.StopCometSound();

		// this.timeoutNextCommetJP1AndJP2.Stop();
		// this.timeoutNextCommetJP3.Stop();
		// this.timeoutNextCommetJP4.Stop();
		// this.timeoutJP4ShowTime.Stop();
		// this.timeoutJP3ShowTime.Stop();
		// this.timeoutJP2AndJP1ShowTime.Stop();
		//this.timeoutNextCommetCash.Stop();
		// let jp = this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption ;
		// if (jp?.AwardType == AwardType.Jackpot) {
		// 	let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp.AwardName));
		// 	video.Stop();			
		// 	this.intervalvideoFadeOutTimer?.Stop();
		// 	this.intervalStopFountainTimer?.Stop();
		// 	video.Hide();
		// 	this.audio.Stop(this.resid.ScopedResourceName(jp.AwardName + "Background"));
		// 	this.audio.Stop(this.resid.ScopedResourceName(jp.AwardName + "Voice"));
		// 	SlotGameType1Shared.Instance().jackpotFountain.get(jp.AwardName as JackpotLevel)?.RequestStop(this.resid);
		// 	video = null;			
		// }				
		//this.stateMachine.ChangeState(SpinAndHoldState.FinalMessage);
		
	}

	protected OnFinalMessageBegin(): void {
		//MOVE POSITIONnextCommetCash
		//this.holdingFeature.Stop();
		this.spineBonusTitleAward?.state?.setAnimation(0,"anim",true);
		this.spineWinAward?.state?.setAnimation(0,"anim",true);
		this.audio.PlayLoop(this.resid.ScopedResourceName("final"));
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		//this.screenProtocol?.Send(new SpinAndHoldMessages.StartBounceFinalBonus, this.screenProtocolScope);
		// let spinEndAction = this.simpleEndSpinAction.find(b=>b.Phase == "End");
		this.params.clientState.SetWin(this.simpleEndSpinAction.WinSinceGameStart.TotalWin.InCents, "TotalBonus Win")
		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.params.clientState.Win), service.moneyFormatter.FormatCurrency(this.params.clientState.Win));
		this.messageContainerPIXIAPP.visible = true;
		this.finalMessageContainerPIXIAPP.visible = true;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;	
		this.finalMessageContainerPIXIAPP.interactive = true;		
		//this.ShowContainer(SpinAndHoldContainer.FinalMessage);		
		this.CreateTransitionPixi(this.gameViewApp);
		//this.VoicePlay = true;		
		this.robotPlay.BonusConfirm("FinalMessage");		
	}

	// protected ClearDataIntervals(){
	// 	this.nextCommetJP1AndJP2 = null;
	// 	this.nextCommetJP3 = null;
	// 	this.nextCommetJP4 = null;
	// 	this.JP4ShowTime = null;
	// 	this.JP3ShowTime = null;
	// 	this.JP2AndJP1ShowTime = null;
	// 	this.nextCommetCash = null;
	// }

	protected OnFinalMessageEnd(): void {
		
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.Stop(this.resid.ScopedResourceName("final"));
		this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
		//this.VoicePlay = true;
		//this.plusOneAnim.Hide();
		//this.screenProtocol?.Send(new SpinAndHoldMessages.StopBounceFinalBonus, this.screenProtocolScope);
		
		this.holdingFeature.Stop();
		this.holdingFeature.Hide();		
	}

	/**
	 *	External messages
	**/
	public OnBonusPickElement(pickElement: BonusPickElement): void {
		throw "Not implemented"
	}

	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		throw "Not implemented"
	}

	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void {
		throw "Not implemented"
	}

	
	public OnSimpleSpinRunResult(): void {
		
		this.indexsimpleLastSpinAction++;
		this.simpleLastBonusAction = this.simpleAllBonusSpinAction[this.indexsimpleLastSpinAction];
		// Log.Debug(this.logGroup, "OnSimpleSpinRunResult()", this.simpleLastBonusAction);
		//console.log("lastSpin:", this.simpleAllBonusSpinAction);

		
		

		//let this.simpleLastBonusAction = runResult.RunResult as any as SpinAndHoldRunResult;
		
		
		
		this.params.clientState.SetWin(this.simpleLastBonusAction.WinAmounts.TotalWin.InCents, `${this.BonusName()} OnSimpleSpinRunResult()`);
		//this.lastSpinResult = this.simpleLastBonusAction;

		let targets: SpinTargetParams[] = [];

		for (let i = 0; i < this.simpleLastBonusAction.SpinWithFeatures.ReelStops.length; i++) {
			// anticipation can't be on the first reel
			let t: SpinTargetParams = {
                position: this.simpleLastBonusAction.SpinWithFeatures.ReelStops[i],
                anticipation:false ,
                firstAnticipationReelIndex : -1
            };
            
			targets.push(t);
		}

		this.spinAnimation2.SetTargets([]);
		this.reelSetMapper2.SetTargets(targets);

		let scatter = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
		this.scatterRandomAwardFeature.SetAwards(scatter.ScattersPositionThisSpin);

		this.robotPlay.OnSpinStopAvailable();
	}

	public OnBonusRunResult(): void {}

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		// Log.Debug(this.logGroup, "OnBonusTotalResult()", totalResult);
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish()", bonusFinish);
	}

	protected bet: SlotGameBet = null;
	// protected startConfig: SpinAndHoldStartConfig ;
	protected indexsimpleLastSpinAction : number = 0;	
	protected simpleAllBonusSpinAction: SpinAndHoldSpinAction[] = [];
	protected simpleLastBonusAction: SpinAndHoldSpinAction;
	protected simpleEndSpinAction: SpinAndHoldEndAction = null ;
	protected startAction : SpinAndHoldStartAction;
	//protected bonusMultiplier : number = 1;
	protected constructReelsParams: ConstructReelsParams;

	public Prepare(bonusStartConfig: IBonusStartConfig)
	{

		// const spinAndHoldStartConfig: SpinAndHoldStartConfig = bonusStartConfig as any as SpinAndHoldStartConfig;


		// actions: ISimpleBonusSpinAction[], bet: SlotGameBet, constructReelsParams: ConstructReelsParams): void {		
		this.holdingFeatureIndex = 0;
		// Log.Debug(this.logGroup, "Prepare()", startConfig);
		this.winAwardBonus = 0;

		const spinAndHoldActions = bonusStartConfig.actions as (SpinAndHoldStartAction | SpinAndHoldSpinAction | SpinAndHoldEndAction)[];
		this.simpleAllBonusSpinAction = spinAndHoldActions.filter(b=> b.Bonus != "BasegameSpinAction" && b.Phase != "Start" && b.Phase == "Spin") as SpinAndHoldSpinAction[];
		
		//console.log('AllSpinDataFilter',this.simpleAllBonusSpinAction);
		this.simpleEndSpinAction = spinAndHoldActions.find(b=>b.Phase == "End") as SpinAndHoldEndAction;
		assertNotNullish(this.simpleEndSpinAction, `Can't show ${this.bonusName}, no end action`);

		// debugger
		assertNotNullish(bonusStartConfig.bet, `Can't show ${this.bonusName}, no bet`);
		this.bet = bonusStartConfig.bet;

		this.startAction = spinAndHoldActions.find(b => b.Phase == "Start") as SpinAndHoldStartAction;	
		assertNotNullish(this.startAction, `Can't show ${this.bonusName}, no start action`);


		assertNotNullish(this.startAction, `Can't show ${this.bonusName}, no start action`);

		const reelSet = this.config.MultiReelSets[this.startAction.ReelSetId];
		assertNotNullish(reelSet, "ReelSet must be loaded");

		// const message = (BonusNameMap[this.bonusName] ?? "Bonus") + " x" + this.simpleConfigSpinAndHold.Multiplier ?? 1; 
		let xratio = 1;
		let yratio = 1;

		const extended = this.startAction.Types.includes(MultiBonusType.Double) || this.bonusName == "ExtendedSpinAndHold";
		const rect = extended
			// extended
			? new Rect(Scale.X(115.0) * xratio, Scale.Y(Settings.Screens == 2 ? 132 : 1215) , Scale.W(1690.0) * xratio, Scale.H(1870.0) * yratio)
			// normal
			: new Rect(Scale.X(74.0) * xratio, Scale.Y(10.0) + (Settings.ScreenHeight * (Settings.Screens - 1)) , Scale.W(1774.0) * xratio, Scale.H(885.0) * yratio);

		this.constructReelsParams = {
			PlayWindow: this.startAction.PlayWindow,
			ReelSet: reelSet,
			WindowRect: rect,
			Extended: extended
		};


					
		this.jackpotSharedHit = null;


		this.bonusMultiplier?.SetLevelMultiplier(this.startAction.Multiplier);

		//console.log("lastSpin:", this.simpleConfigSpinAndHold);
		//this.scatterRandomAwardFeature.SetAwards(this.startConfig.StartingState.FeatureResults.ScatterRandomAward);
		//console.log("ApiResultS&H:",startConfig);
		// Log.Debug(this.logGroup, "Prepare() config: ", this.simpleConfigSpinAndHold);
		// reset targets
		//console.log("config",this.simpleConfigSpinAndHold);




		// redraw reel to apply scatter values
		//this.RedrawAllReels();

		// THIS also resets the list from previious bonus
		// saves fresh positions on start
		//this.scatterPositions = this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersPosition;
		this.indexsimpleLastSpinAction = -1;
		//this.skipMessageCommets.style.display= "none";
		//this.skipCometMessageContainer.alpha = 0;
		this.scatterPositions = [];
	}


	public HistoryView(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {
		const spin: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as SpinAndHoldSpinAction;
		
		// remove first action basegame and all later actions
		const actionsToCheck = gameState.Actions.slice(1, actionIndex +1);
		// find start action of this bonus

		// find first start from reverse
		const start: SpinAndHoldStartAction = [...actionsToCheck].reverse().find(a => a.Phase == "Start") as SpinAndHoldStartAction; 

		const reelSet = this.config.MultiReelSets[start.ReelSetId];
		assertNotNullish(reelSet, `ReelSet ${start.ReelSetId} not found`);

		const playWindow = start.PlayWindow;

		

		let bonusView: HTMLElement = CreateElement("div", {
			classes: ["bonusView", "SpinAndHoldHistory"],
			style:
			{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}
		});

		const bonusMultiplier = spin.Multiplier || 1;

		let variantNames: string[] = [];

		let reelView: HTMLElement = null;
		let reelViewHeight: number = Scale.H(700);

		if (start.Action == "MultiBonusStartAction")
		{
			const multiStart = start as MultiBonusStartAction;
			if (multiStart.Types.includes(MultiBonusType.Double))
			{
				reelViewHeight = Scale.H(900);
			}

			if (multiStart.Types.includes(MultiBonusType.Jackpot))
			{
				variantNames.push("JACKPOT");
			}

			if (multiStart.Types.includes(MultiBonusType.Multiplier))
			{
				variantNames.push("MULTIPLIER x" + bonusMultiplier.toString());
			}

			if (multiStart.Types.includes(MultiBonusType.Double))
			{
				variantNames.push("DOUBLE");
			}
		}
		else
		{
			variantNames.push("MULTIPLIER x" + bonusMultiplier.toString());
		}

		CreateElement("h2", {
			classes: ["ui", "inverted", "dividing", "center", "aligned", "header"],
			parentToAppend: bonusView,
			innerHTML: variantNames.join(" | ")
		});

		let gameView: HTMLElement = CreateElement("div", {
			classes: ["gameBackground"], parentToAppend: bonusView,
			style:
			{
				width: Scale.Wpx(900),
				height: reelViewHeight.px(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				alignItems: "center",
				backgroundImage: this.gameBackground,
			}
		});

		if (spin.Phase == "Spin" || spin.Phase == "Start") {
			console.log(`Scatter positions`, (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition);
			// reel view
			reelView = CreateElement("div", {
				classes: ["reelView"], parentToAppend: gameView,
				style:
				{
					width: Scale.Wpx(900),
					height: reelViewHeight.px(),
				}
			});


			let reelTable: HTMLElement = CreateElement("table", { classes: ["reelTable"], parentToAppend: reelView, style: { width: "100%", height: "100%" } });
			for (let i = 0; i < playWindow.Height; i++) {
				let tr: HTMLElement = CreateElement("tr", { classes: ["tr"], parentToAppend: reelTable });

				for (let j = 0; j < playWindow.Width; j++) {

					let coulmnWidth: number = 100 / playWindow.Width;
					let rowHeigt: number = 100 / playWindow.Height;
					let reel = reelSet.find((r) => r.Row == i && r.Col == j);

					if (reel == null) {

					}
					else {
						let td: HTMLTableDataCellElement = CreateElement("td", {
							classes: ["td"], parentToAppend: tr,
							style: {
								//border:"5px solid blue",
								fontSize: Scale.fhpx(80),
								width: "" + (coulmnWidth * reel.ColSpan) + "%",
								height: "" + (rowHeigt * reel.RowSpan) + "%",
							}
						});
						td.colSpan = reel.ColSpan;
						td.rowSpan = reel.RowSpan;

						// TODO what if the action is start action?
						// should just skip it...


						let scatterPosition: AwardOptionPosition = (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);
						console.log(`Checking col ${j} row ${i}: `, scatterPosition);

						if (scatterPosition) {
							//td.innerHTML = ""+scatterPosition.AwardOption.BetMultiplier;
							let award: HTMLElement = CreateElement("div", {
								classes: ["award"], parentToAppend: td,
								style:
								{
									width: "100%",
									height: "100%",
									color: "black",
									display: "flex",
									//backgroundImage: this.historySymbolImg.CssBackground(),
									//backgroundRepeat: "no-repeat",
									//backgroundSize: "cover",
									alignItems: "center",
									justifyContent: "center",
								}
							});

							let img: HTMLElement = CreateElement("div", {
								classes: ["img"], parentToAppend: award,
								style:
								{
									width: "100%",
									height: "75%",
									//backgroundImage: this.historySymbolImg.CssBackground(),
									backgroundRepeat: "no-repeat",
									backgroundSize: "contain",
									backgroundPosition: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}
							});

							let symbol = this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").imgResource.cloneNode() as HTMLElement;
							symbol.style.width = "100%";
							symbol.style.height = "auto";
							img.appendChild(symbol);

							let textHTML = CreateElement("div",{
								style : {
									fontSize :  Scale.fhpx(30),
									textAlign: "center",
									justifyContent: "center",
									fontFamily: "NotoSansDisplay-Bold",
									alignContent: "center",
									zIndex : ZIndex.BonusWin + "",
									color : "white",
									textShadow : `${Scale.fhpx(1)} ${Scale.fhpx(1)}  ${Scale.fhpx(1)} black , ${Scale.fhpx(2)} ${Scale.fhpx(2)}  ${Scale.fhpx(2)} black`,	
									position : "absolute",									
								}
							})

							
							this.scatterRandomAwardFeature?.GetHistoryValue({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: textHTML,
								multiplier: bonusMultiplier
							});
							
							img.appendChild(textHTML);
							
						} else {
							let symbol = this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + spin.SpinWithFeatures.ExpectedSymbols[j][i]).imgResource.cloneNode() as HTMLElement;
							//symbol.style.display = "flex";
							symbol.style.width = "100%";
							symbol.style.height = "auto";
							symbol.style.filter = "grayscale(100%)";
							td.appendChild(symbol);
						}
					}
				}
			}
		}
		else if (spin.Phase == "End") {
			let endAction = gameState.Actions[actionIndex]  as SpinAndHoldEndAction;
			gameView.style.flexDirection= "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width:"100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",					
					fontSize : Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor : "rgba(0,0,0,0.5)",
					fontSize : Scale.fhpx(100),
					color: "white",	
					textShadow:`0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,		
					backgroundImage : "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",		
				}
			});
			winView.innerText =  service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)
		}

		return bonusView;
	}

	public HistoryStats2(actionIndex: number , gameState: SimpleSlotGameState): ActionStats
	{
		let action: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as SpinAndHoldSpinAction;

		let stats: HistoryStats[] = [];
		stats.push({key: "Multiplier", value: "x" + (action.Multiplier || 1).toString()});
		if(action.Phase == "Start" || action.Phase =="Spin")
		{
			stats.push({key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed)});
			stats.push({key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining)});
		}

		// find end action
		let endAction: SpinAndHoldEndAction = null;
		for (let i = actionIndex; i < gameState.Actions.length; i++)
		{
			let action = gameState.Actions[i];
			if (action.Bonus != this.bonusName) break;
			if (action.Phase == "End")
			{
				endAction = action as SpinAndHoldEndAction;
				break;
			}
		}

		let revealedScattersCount = 0;
		if (action.Phase == "End")
		{
			revealedScattersCount = endAction.Awards.length;
			
			// full win
			if (endAction.FullAward)
			{
				stats.push({key: "Full screen win:", value: service.moneyFormatter.FormatCurrency(endAction.FullAward.Value.InCents)});
			}
		}
		else
		{
			revealedScattersCount = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersTotal;
		}

		if (!endAction)
		{
			return {
				Bonus: action.Bonus,
				Action: action.Action,
				Stats: stats
			};
		}


		let awards = endAction.Awards.filter((award, index) => index < revealedScattersCount);
		stats.push({key: "Bonus Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceBonusStart.TotalWin.InCents)});
		stats.push({key: "Total Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)});
		


		// jp scatters
		let jpScatters = awards.filter(p => p.AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot);
		for (let jps of jpScatters)
		{
			// jackpot win
			stats.push({key: `${jps.AwardOptionPosition.AwardOption.AwardName} win:`, value: service.moneyFormatter.FormatCurrency(jps.Value)});
		}
		
		// cash scatters
		let cashScatters = awards.filter(p => 
			p.AwardOptionPosition.AwardOption.AwardType == AwardType.BetMultiplier ||
			p.AwardOptionPosition.AwardOption.AwardType == AwardType.Credit
		);
		
		if (cashScatters.length > 0)
		{
			let cashScatterWin: number = cashScatters.reduce((total, award) => total + award.Value.InCents, 0);
			stats.push({key: "Cash scatters win:", value: service.moneyFormatter.FormatCurrency(cashScatterWin)});
		}

		return {
			Bonus: action.Bonus,
			Action: action.Action,
			Stats: stats
		};
	}

	public redrawPixiReels() {
		this.ReelBackgroundLoaded();
		this.HideHoldingReels();
		for (let reelIndex = 0; reelIndex < this.spinnableReels2.pixiCanvas.length; reelIndex++) {
			for (let rowIndex = 0; rowIndex < this.spinnableReels2.pixiCanvas[reelIndex].length; rowIndex++) {
				this.DrawSymbol(reelIndex, rowIndex);
			}
		}
		//console.log("PIXI Finish SpinAndHold:", this.gameName);
	}

	//app from base game 
	protected gameViewApp : PIXI.Container = null;
	//main container app bonus 
	protected containerBonusViewApp : PIXI.Container = null;

	protected created: boolean = false;
	public GameSelected(app : PIXI.Container)
	{		
		this.gameViewApp = app;
		//create view main bonus 		
		this.containerBonusViewApp = new PIXI.Container();				
		this.containerBonusViewApp.name = "containerBonusViewApp"+this.bonusName;
		this.containerBonusViewApp.width = Settings.ScreenWidth;
		this.containerBonusViewApp.height = Settings.ScreenHeight * Settings.Screens;
		this.gameViewApp.addChild(this.containerBonusViewApp);
		this.containerBonusViewApp.parent.setChildIndex(this.containerBonusViewApp,1);	
		//create award background show win jp	
		this.awardJPShowPIXIAPP.CreatePIXIAPP();
		this.containerBonusViewApp.addChild(this.awardJPShowPIXIAPP.ViewPIXIAPP());
		
		this.ConstructReels2(this.constructReelsParams);

		assertNotNullish(this.containerBonusViewApp, "Container bonus view app must be created");
		this.spinnableReels2.Create(this.containerBonusViewApp);		

		

		this.scatterRandomAwardFeature.UpdateReels({
			playWindow: this.startAction.PlayWindow,
			reelSet: this.config.MultiReelSets[this.startAction.ReelSetId].map(reel => reel.Symbols)
		});
		
		this.scatterRandomAwardFeature.UpdateBet(this.bet);
		this.scatterRandomAwardFeature.Start();



		let targets: SpinTargetParams[] = this.constructReelsParams.ReelSet.map(r => {
            
            let stop: number = 0;
            if (this.startAction.ReelStops &&
                this.startAction.ReelStops[r.Index])
            {
                stop = this.startAction.ReelStops[r.Index];
            }

            return <SpinTargetParams>{
                position: stop,
                anticipation: false,
                firstAnticipationReelIndex: -1,
            };
        });
        
		this.reelSetMapper2.SetTargets(targets, true);

		const scatterRandomAward = this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult;
		this.holdingFeature.UpdateReels(this.spinnableReels2);
		this.holdingFeature.CreatePIXIAPP();
		this.holdingFeature.Start(scatterRandomAward.ScattersPositionThisSpin, 1, this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").showAward, false);


		this.CreateContainersPIXIAPPScreen1();
		this.CreateContainersPIXIAPPScreen2();

		if(this.jackpotSharedShow != null)
		{
			this.jackpotSharedShow.Create();
			this.containerBonusViewApp.addChild(this.jackpotSharedShow.View());			
		}

		this.bonusMultiplier?.Create();
		if(this.bonusMultiplier != null)this.containerBonusViewApp?.addChild(this.bonusMultiplier.View());
		

		this.created = true;
	}

	protected introMessageContainerPIXIAPP: PIXI.Container = null;
	protected finalMessageContainerPIXIAPP: PIXI.Container = null;	
	protected messageContainerPIXIAPP: PIXI.Container = null;	
	protected winCountTextPIXIAPP : PIXI.Text = null;
	protected spinRemainingTextPIXIAPP : PIXI.Text = null;
	protected bonusGameInfoStats: PIXI.Container = null;
	protected bonusGameAwardViewPIXIAPP: PIXI.Container = null;
	//spine
	protected spineBonusTitle: Spine = null;
	protected spineWinCountContainer: Spine = null;	
	protected spineSpinsRemaining: Spine = null;	
	
	//skipMessageContainer 
	protected skipCometMessageContainer : PIXI.Container = null;
	protected spriteintroTextureMessageContainerApp : PIXI.Sprite = null;
	protected spritefinalTextureMessageContainerApp : PIXI.Sprite = null;
	protected finalbuttonIntroContainerApp: PIXI.Container = null;
	protected buttonIntroContainerApp: PIXI.Container = null;
	protected CreateContainersPIXIAPPScreen1(){
		//add holding feature pixi
		if(this.holdingFeature != null)	this.containerBonusViewApp.addChild(this.holdingFeature.ViewPIXIAPP());
		//add commetView pixi
		// this.commetView.CreatePIXIAPP();
		// this.containerBonusViewApp.addChild(this.commetView.ViewPIXIAPP());
		//this.containerBonusViewApp.parent.setChildIndex(this.holdingFeature.GetViewPIXIAPP(),1)




		//fix stops spinnable reels 
		if (Settings.touchToStop == true) {
			this.gameViewApp.addEventListener('mousedown', () => {
				this.spinAnimation2.RequestStop();
			});
		}

		this.messageContainerPIXIAPP  = new PIXI.Container()
		this.messageContainerPIXIAPP.width = Scale.W(1920);
		this.messageContainerPIXIAPP.height = Scale.H(1080);
		this.messageContainerPIXIAPP.x =  0
		this.messageContainerPIXIAPP.y =  Settings.ScreenHeight * (Settings.Screens-1);
		this.messageContainerPIXIAPP.name = "messageContainerApp";
		this.messageContainerPIXIAPP.visible = false;
		this.containerBonusViewApp.addChild(this.messageContainerPIXIAPP);

		this.introMessageContainerPIXIAPP = new PIXI.Container();
		this.introMessageContainerPIXIAPP.width = Scale.W(1152);
		this.introMessageContainerPIXIAPP.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.introMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.introMessageContainerPIXIAPP.width / 2)
		this.introMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.introMessageContainerPIXIAPP.height / 2)) - Scale.Y(75);
		this.introMessageContainerPIXIAPP.name = "introMessageContainer";
		this.messageContainerPIXIAPP.addChild(this.introMessageContainerPIXIAPP);

		let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spriteintroSpanishMessageContainerApp.width = Scale.W(1152),
		spriteintroSpanishMessageContainerApp.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.addChild(spriteintroSpanishMessageContainerApp);


		this.spriteintroTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro);		
		//this.spriteintroTextureMessageContainerApp.width = Scale.W(1052),
		//this.spriteintroTextureMessageContainerApp.height = Scale.H(548);
		this.spriteintroTextureMessageContainerApp.scale.set(Scale.H(1),Scale.W(1));
		this.spriteintroTextureMessageContainerApp.anchor.set(0.5,0.5);
		this.spriteintroTextureMessageContainerApp.x =  Scale.W(1152) / 2
		this.spriteintroTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.introMessageContainerPIXIAPP.addChild(this.spriteintroTextureMessageContainerApp);

		
		

		this.buttonIntroContainerApp = new PIXI.Container()
		this.buttonIntroContainerApp.name="buttonIntroContainerApp"
		this.buttonIntroContainerApp.width = Scale.W(600);
		this.buttonIntroContainerApp.height = Scale.H(300);
		this.buttonIntroContainerApp.y = Scale.H(600);
		this.buttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		this.buttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		this.buttonIntroContainerApp.interactive = true;
		this.introMessageContainerPIXIAPP.addChild(this.buttonIntroContainerApp);

		let spritebuttonIntroContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonIntroContainerApp.width = Scale.W(600),
		spritebuttonIntroContainerApp.height = Scale.H(300);
		this.buttonIntroContainerApp.addChild(spritebuttonIntroContainerApp);

		//create text style
		let textstyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(100),
			//fontStyle: 'italic',
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),			
			wordWrap: true,
			wordWrapWidth: Scale.fh(300),
			lineJoin: 'round',
			textBaseline : "middle",			
        });
        //this.app.renderer.view.style.position = 'fixed';
       let startTextView = new PIXI.Text(this.translator.t.freegameStart, textstyle);
	   startTextView.anchor.set(0.5,0.5);
	   startTextView.x = (Scale.W(600) / 2);
	   startTextView.y = (Scale.W(300) / 2);	   	   
	   this.buttonIntroContainerApp.addChild(startTextView);
        
		//spritethis.buttonIntroContainerApp.tint = 0xff0000;		
		this.buttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
				this.introMessageContainerPIXIAPP.visible = false;
				this.stateMachine.ChangeState(SpinAndHoldState.MultiplierShow);				
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});



		//Create Final MessageContainer

		

		this.finalMessageContainerPIXIAPP = new PIXI.Container();
		this.finalMessageContainerPIXIAPP.width = Scale.W(1152);
		this.finalMessageContainerPIXIAPP.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.finalMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.finalMessageContainerPIXIAPP.width / 2)
		this.finalMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.finalMessageContainerPIXIAPP.height / 2)) - Scale.Y(75);
		this.finalMessageContainerPIXIAPP.name = "finalMessageContainerApp";
		this.finalMessageContainerPIXIAPP.visible = false;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;	
		this.finalMessageContainerPIXIAPP.interactive = true;		
		this.messageContainerPIXIAPP.addChild(this.finalMessageContainerPIXIAPP);

		
		let spritefinalSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spritefinalSpanishMessageContainerApp.width = Scale.W(1152),
		spritefinalSpanishMessageContainerApp.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.addChild(spritefinalSpanishMessageContainerApp);


		this.spritefinalTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal);		
		//this.spritefinalTextureMessageContainerApp.width = Scale.W(1052),
		//this.spritefinalTextureMessageContainerApp.height = Scale.H(548);
		this.spritefinalTextureMessageContainerApp.scale.set(Scale.H(1),Scale.W(1));
		this.spritefinalTextureMessageContainerApp.anchor.set(0.5,0.5);
		this.spritefinalTextureMessageContainerApp.x =  Scale.W(1152) / 2
		this.spritefinalTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.finalMessageContainerPIXIAPP.addChild(this.spritefinalTextureMessageContainerApp);

		

		this.finalbuttonIntroContainerApp = new PIXI.Container()
		this.finalbuttonIntroContainerApp.name="finalbuttonIntroContainerApp"
		this.finalbuttonIntroContainerApp.width = Scale.W(600);
		this.finalbuttonIntroContainerApp.height = Scale.H(300);
		this.finalbuttonIntroContainerApp.y = Scale.H(600);
		this.finalbuttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		this.finalbuttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		this.finalbuttonIntroContainerApp.interactive = true;
		this.finalbuttonIntroContainerApp.interactiveChildren = true;
		
		this.finalMessageContainerPIXIAPP.addChild(this.finalbuttonIntroContainerApp);

		let spritebuttonFinalContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonFinalContainerApp.width = Scale.W(600),
		spritebuttonFinalContainerApp.height = Scale.H(300);
		//spritebuttonFinalContainerApp.tint = 0xff0000;
		this.finalbuttonIntroContainerApp.addChild(spritebuttonFinalContainerApp);	

		let finalTextView = new PIXI.Text(this.translator.t.freegameExit, textstyle);
		finalTextView.x = (Scale.W(600) / 2);
		finalTextView.y = (Scale.W(300) / 2);
		finalTextView.anchor.set(0.5,0.5),
		this.finalbuttonIntroContainerApp.addChild(finalTextView);

		this.finalbuttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {			
			 if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});


		this.skipCometMessageContainer = new PIXI.Container();
		this.skipCometMessageContainer.name = "skipCometMessageContainer";
		this.skipCometMessageContainer.height = Settings.ScreenHeight;
		this.skipCometMessageContainer.width = Settings.ScreenWidth;
		this.skipCometMessageContainer.x = Settings.ScreenWidth/2;		
		this.skipCometMessageContainer.y = (Settings.ScreenHeight * Settings.Screens - 1) - Scale.Y(300);
		//this.skipCometMessageContainer.alpha = 0;
		this.skipCometMessageContainer.visible = false;


		
		this.containerBonusViewApp.addChild(this.skipCometMessageContainer);

		let graphics = new PIXI.Graphics();
		graphics.beginFill(0xffffff);
		graphics.tint = 0x000000;
		graphics.alpha = 0.8;
		graphics.drawRoundedRect(0, 0, Scale.W(576), Scale.H(216),50);
		graphics.endFill();
		graphics.pivot.set(Scale.W(576)/2,Scale.H(216)/2);	
		this.skipCometMessageContainer.addChild(graphics);

		let skipMessageCommets =new PIXI.Text(this.translator.t.skipMessageCommets,{
			fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(50),			
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),	
			wordWrapWidth : Scale.H(487),		
			wordWrap: true,			
			lineJoin: 'round',
			align : "center",			
			//textBaseline : "middle",			
		});
		skipMessageCommets.pivot.set(skipMessageCommets.width/2,skipMessageCommets.height/2);
		this.skipCometMessageContainer.addChild(skipMessageCommets);
		//skipMessageBackgroundCommets.appendChild(this.translator.Anchor(() => this.translator.t.skipMessageCommets));
		
		this.translator.SetOnLanguageChangedCallback(() => {				
			this.spriteintroTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro;
			this.spritefinalTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal;	
			startTextView.text = this.translator.t.freegameStart;
			finalTextView.text = this.translator.t.freegameExit;
			skipMessageCommets.text = this.translator.t.skipMessageCommets;
		});	
		this.skipMessageHide = this.systemContext.TimingContext().CreateTimeout("skipMessageHideShowTime", 1500, () => {
			this.skipCometMessageContainer.visible = false;			
		});
	}


	// protected showBonusMultiplier(){
	// 	let ScatterRandomAward = this.simpleConfigSpinAndHold.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult;
	// 			//let ScatterRandomAward = this.simpleLastBonusAction.Spin.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
	// 			if (ScatterRandomAward != null) {					
	// 				this.holdingFeature.Start(ScatterRandomAward.ScattersPositionThisSpin, this.simpleConfigSpinAndHold.Multiplier);					
	// 			}
	// 			// Log.Debug(this.logGroup, "Intro message confirmed");				
	// 			this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);		
	// }

	protected holdingFeatureIndex : number = 0;
	protected NextScatterMultiplier() {
		if (this.stateMachine.IsState(SpinAndHoldState.MultiplierShow) != true ) return		
		if (this.holdingFeatureIndex < (this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPositionThisSpin.length && this.startAction.Multiplier > 1) {
			this.holdingFeature.StartShowBonusScatter((this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPositionThisSpin[this.holdingFeatureIndex], this.startAction.Multiplier,this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").showAward);
			this.holdingFeatureIndex++;			
		}
		else {
			this.holdingFeatureIndex == 0;
			this.Show();			
			this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);
		}
	}

	



	protected CreateContainersPIXIAPPScreen2(){
		
		let containerViewScreen2 = new PIXI.Container();
		//containerViewScreen2.width = Settings.ScreenWidth;
		//containerViewScreen2.height = Settings.ScreenHeight;
		containerViewScreen2.y = Settings.ScreenHeight * (Settings.Screens - 2);
		containerViewScreen2.name = "containerViewScreen2PIXIAPP";
		this.containerBonusViewApp.addChild(containerViewScreen2);
		this.SetScaleSpinsRemaining(containerViewScreen2);


		this.bonusGameInfoStats = new PIXI.Container();
		this.bonusGameInfoStats.name = "bonusGameInfoStats";
		containerViewScreen2.addChild(this.bonusGameInfoStats);
		if (Settings.Screens == 2) {
			this.bonusGameInfoStats.position.set(Scale.X(0), Scale.Y(0))
			if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S) {
				this.bonusGameInfoStats.position.set(Scale.X(1019), Scale.Y(-323))
			}
		} 
		this.CreateTitleStckySpin();
		this.CreateScatterWinCount();
		//create text style
		// let textstyle = new PIXI.TextStyle({
        //     fontFamily: 'NotoSansDisplay-Bold',			
		// 	fontSize: Scale.fh(250),			
		// 	fontWeight: 'bold',
		// 	fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
		// 	stroke: 'black',
		// 	strokeThickness: Scale.fh(10),			
		// 	//wordWrap: true,			
		// 	lineJoin: 'round',
		// 	//textBaseline : "middle",			
        // });

		//create Win Text SRA
		let winCountTextPIXIAPP = new PIXI.Text(this.session.ScattersDisplayed, {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: 250,			
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			dropShadow : true,
			dropShadowColor : "#000000",
			dropShadowDistance : 5,
			dropShadowAngle : 0.52,	
			dropShadowAlpha : 1,		
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		winCountTextPIXIAPP.anchor.set(0.5,0.5);
		winCountTextPIXIAPP.scale.set(1,-1);
		//winCountTextPIXIAPP.position.set(Scale.W(301),Scale.H(300));	   	   		
		//scatterWinCountContainer.addChild(winCountTextPIXIAPP);
		this.winCountTextPIXIAPP = winCountTextPIXIAPP;

		//Create Win Text SRA info
		let winTextPIXIAPP = new PIXI.Text(this.translator.t.totalwinHoldAndSpin, {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: 55,			
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,	
			dropShadow : true,
			dropShadowColor : "#000000",
			dropShadowDistance : 5,
			dropShadowAngle : 0.52,	
			dropShadowAlpha : 1,			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		winTextPIXIAPP.anchor.set(0.5,0.5);
		winTextPIXIAPP.position.set(0,(winTextPIXIAPP.height+54)*-1);
		winTextPIXIAPP.scale.set(1,-1);
		//winTextPIXIAPP.position.set(Scale.W(300),Scale.H(440));	   	   		
		//scatterWinCountContainer.addChild(winTextPIXIAPP);
		
		//this.winCountTextPIXIAPP = winTextPIXIAPP;

		//add container to spine
		let containerchildrensSpineWinCount = this.spineWinCountContainer?.children as PIXI.Container[];
		containerchildrensSpineWinCount?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(winCountTextPIXIAPP);
				container.addChild(winTextPIXIAPP);
			}
		});


		this.CreateSpinsRemaining();
		this.translator.SetOnLanguageChangedCallback(() => {

			winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			//spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});

		this.CreateAwarViewPIXIAPP(containerViewScreen2);
	}

	protected SetScaleSpinsRemaining(containerViewScreen2 : PIXI.Container){
		if (Settings.Screens == 2 ) {
			containerViewScreen2.scale.set(0.55);
			containerViewScreen2.position.set(Scale.X(-135), Scale.Y(481));
			
		}
		else if(Settings.Enable2plus1 == true ){
			containerViewScreen2.scale.set(0.55);
			containerViewScreen2.position.set(Scale.X(-135), Scale.Y(1561));
		}

	}

	protected CreateTitleStckySpin() {
		//create container and spine bonus title 
		let bonusTitleContainer = new PIXI.Container();
		bonusTitleContainer.name = "bonusTitleContainer";
		this.bonusGameInfoStats.addChild(bonusTitleContainer);
		this.spineBonusTitle = CreateSpineResources(this.jsonBonusTitleSpine);

		bonusTitleContainer.x = Settings.ScreenWidth / 2;
		bonusTitleContainer.y = Scale.Y(144);
		bonusTitleContainer.addChild(this.spineBonusTitle);
		bonusTitleContainer.pivot.set(this.spineBonusTitle.width / 2, this.spineBonusTitle.height / 2);
		//this.spineBonusTitle = spineBonusTitle;
	}

	protected CreateScatterWinCount(){
		//create container and spine WinCount 
		let scatterWinCountContainer = new PIXI.Container();	
		scatterWinCountContainer.x = Settings.ScreenWidth / 2;
		scatterWinCountContainer.y = Settings.ScreenHeight / 2 ;
		scatterWinCountContainer.name = "scatterWinCountContainer";
		this.bonusGameInfoStats.addChild(scatterWinCountContainer);
		this.spineWinCountContainer = CreateSpineResources(this.jsonWinCountSpine);		
		scatterWinCountContainer.addChild(this.spineWinCountContainer);
		scatterWinCountContainer.pivot.set(this.spineWinCountContainer.width / 2 , this.spineWinCountContainer.height/2);
		this.spineWinCountContainer?.state.setAnimation(0,"anim",true);
	}

	protected CreateSpinsRemaining() {
		//create container and spine Spins Remaining
		let spinsRemainingContainer = new PIXI.Container();
		spinsRemainingContainer.x = Settings.ScreenWidth / 2;

		spinsRemainingContainer.name = "spinsRemainingContainer";
		this.bonusGameInfoStats.addChild(spinsRemainingContainer);
		this.spineSpinsRemaining = CreateSpineResources(this.jsonSpinsRemainingSpine);
		spinsRemainingContainer.addChild(this.spineSpinsRemaining);
		this.spineSpinsRemaining.scale.set(Scale.XY(1.5));
		this.spineSpinsRemaining.state.apply(this.spineSpinsRemaining.skeleton);
		this.spineSpinsRemaining.state.update(0);
		spinsRemainingContainer.pivot.set(this.spineSpinsRemaining.width / 2, this.spineSpinsRemaining.height / 2);
		spinsRemainingContainer.y = Settings.ScreenHeight - this.spineSpinsRemaining.height / 2;
		this.spineSpinsRemaining?.state?.setAnimation(0, "anim", true);

		//create text spins remaning info
		let spinRemainingTextInfoPIXIAPP = new PIXI.Text(this.translator.t.totalleftHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 35,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextInfoPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextInfoPIXIAPP.scale.set(1, -1);
		spinRemainingTextInfoPIXIAPP.position.set(-50, 0);


		//create spins remaning 
		let spinRemainingTextPIXIAPP = new PIXI.Text(this.session.RunsRemaining, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 70,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextPIXIAPP.scale.set(1, -1);
		spinRemainingTextPIXIAPP.position.set(100, 0);
		this.spinRemainingTextPIXIAPP = spinRemainingTextPIXIAPP;

		//add container to spine
		let containerchildrensSpine = this.spineSpinsRemaining?.children as PIXI.Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(spinRemainingTextInfoPIXIAPP);
				container.addChild(spinRemainingTextPIXIAPP);
			}
		});

		this.translator.SetOnLanguageChangedCallback(() => {

			//winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});

	}

	protected spineWinAward: Spine = null
	protected spineBonusTitleAward: Spine = null
	protected containerValueWinAwardText : PIXI.Text = null;
	protected CreateAwarViewPIXIAPP(view : PIXI.Container){
		this.bonusGameAwardViewPIXIAPP = new PIXI.Container();
		this.bonusGameAwardViewPIXIAPP.name = "bonusGameAwardViewPIXIAPP";
		this.bonusGameAwardViewPIXIAPP.position.set(Settings.ScreenWidth,0);
		view.addChild(this.bonusGameAwardViewPIXIAPP);
		

		//create container and spine bonus title 
		let bonusWinAwardTitle = new PIXI.Container();				
		bonusWinAwardTitle.name = "bonusWinAwardTitle";				
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardTitle);
		this.spineBonusTitleAward = CreateSpineResources(this.jsonBonusWinTitleSpine);
		//this.spineBonusTitleAward.scale.set(Scale.XY(1));		
		this.spineBonusTitleAward.state.timeScale = 1.5;		
		bonusWinAwardTitle.x = Scale.X(78);
		bonusWinAwardTitle.y =  Scale.Y(199); 
		bonusWinAwardTitle.addChild(this.spineBonusTitleAward);


		
		//create container and spine bonus title 
		let bonusWinAwardContainer = new PIXI.Container();
		bonusWinAwardContainer.name = "bonusWinAwardContainer";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardContainer);
		this.spineWinAward = CreateSpineResources(this.jsonWinAwardBonusSpine);
		this.spineWinAward.state.timeScale = 1.5
		//bonusWinAwardContainer.x = Settings.ScreenWidth / 2;
		bonusWinAwardContainer.y = Settings.ScreenHeight / 2;
		bonusWinAwardContainer.addChild(this.spineWinAward);

		console.log("Spine:",this.spineWinAward);



		//create container 
		let containerValue = new PIXI.Container();
		containerValue.name = "containerValue";
		//containerValue.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
		containerValue.scale.set(1, -1);
		containerValue.position.y = (Settings.ScreenHeight * (Settings.Screens - 1)) * -1;


		//add container to spine
		let containerchildrensSpine = this.spineWinAward?.children as PIXI.Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				//create Win Text SRA
				this.containerValueWinAwardText = new PIXI.Text("?", {
					fontFamily: 'NotoSansDisplay-Bold',
					fontSize: 230,
					fontWeight: 'bold',
					fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
					stroke: 'black',
					strokeThickness: 10,
					//wordWrap: true,			
					lineJoin: 'round',
					//textBaseline : "middle",			
				});
				this.containerValueWinAwardText.scale.set(1,-1);
				this.containerValueWinAwardText.anchor.set(0.5, 0.5);
				container.addChild(this.containerValueWinAwardText)
			}
		});

		containerchildrensSpine = null;
		

		//create Win Text SRA
		let containerValueWinAward = new PIXI.Text("?", {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(120),			
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		containerValueWinAward.anchor.set(0.5,0.5);
		containerValue.addChild(containerValueWinAward)

	
		if (Settings.Screens == 2 || Settings.Enable2plus1) {
			this.bonusGameAwardViewPIXIAPP.position.set(Scale.X(3732), Scale.Y(161.5));		
			if(Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S)
				this.bonusGameAwardViewPIXIAPP.position.set(Scale.X(3732), Scale.Y(-300));		
		}
	}



	// protected DestroySpineRunntime(spine : Spine){
	// 	Safe(() => {spine.skeleton.setBonesToSetupPose() });
    //     Safe(() => {spine.skeleton.setToSetupPose() });
    //     Safe(() => {spine.state.update(0) });
    //     Safe(() => {spine.state.clearTracks() });
    //     Safe(() => {spine.state.clearListeners() });
    //     Safe(() => {spine.removeChildren(0,spine.children.length) });
    //     Safe(() => {spine.removeFromParent() });
    //     Safe(() => {spine.destroy({ children: true }) });
	// }

	protected GenerateRandomTextureTEst(texture : PIXI.Sprite) {
		// Generate a random tint color
		const randomColor = Math.random() * 0xFFFFFF;

		// Apply the random tint color
		texture.tint = randomColor;
	}

	public GameExit() {

		this.created = false;

		Safe(() => { this.spinnableReels2.Destroy() });
		//clean data spine and pixi.app
		Safe(() => { this.introMessageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.finalMessageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.messageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.containerBonusViewApp.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.bonusGameInfoStats.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.containerBonusViewApp.removeChildren(0, this.containerBonusViewApp.children.length - 1)});
		Safe(() => { this.containerBonusViewApp.removeFromParent()});
		Safe(() => { this.spineBonusTitle.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.winCountTextPIXIAPP.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.bonusGameAwardViewPIXIAPP.destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.holdingFeature.Destroy()});
		Safe(() => { this.holdingFeature.ViewPIXIAPP().destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.awardJPShowPIXIAPP?.Destroy()});
		Safe(() => { this.jackpotSharedShow?.Destroy(); });	
		Safe(() => { this.bonusMultiplier?.Destroy(); });	
		this.simpleEndSpinAction = null;	
	}


	protected jackpotSharedHit: SharedJackpotWin = null;
	public override SharedJackpotWin(win: SharedJackpotWin) {	
		if (this.jackpotSharedShow?.IsStarted())
		{
			// save for later
			this.jackpotSharedHit = win;
		}
		else
		{
			// show now
			this.jackpotSharedShow?.ShowShared(win);
			this.audio.Play(this.resid.ScopedResourceName("jpsharedVoice"));
			this.jackpotSharedHit = null;
		}
	}
}
